/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AccountCumulativeInfo,
  AddBusinessOTPRequest,
  AddBusinessOTPResponse,
  AdminLoginRequest,
  AdminLoginResponse,
  BranchAppsNetSalesResponse,
  BranchGeneralMetrics,
  BranchNetSalesTimeseriesResponse,
  BranchOrderSourcesNetSalesResponse,
  BranchOrderTagsNetSalesResponse,
  BranchOrderTypesNetSalesResponse,
  BranchPaymentMethodsNetAmountResponse,
  BranchesNetSalesTimeseriesResponse,
  BranchesReportResponse,
  BudgetResponse,
  BudgetValidationErrorResponse,
  Business,
  BusinessInfo,
  BusinessInstallationStatusResponse,
  BusinessReportAppsNetSalesResponse,
  BusinessReportBranchesOrderBy,
  BusinessReportBranchesWithDiscountAmountAndQuantityResponse,
  BusinessReportBranchesWithNetAmountPerPaymentMethodResponse,
  BusinessReportBranchesWithNetSalesAndOrderCountPerMarketplaceAppResponse,
  BusinessReportBranchesWithNetSalesAndOrderCountPerOrderSourceResponse,
  BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTagResponse,
  BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTypeResponse,
  BusinessReportBranchesWithNetSalesPerOrderAndOrderCountResponse,
  BusinessReportBranchesWithOrderCountAndNetSalesResponse,
  BusinessReportBranchesWithVoidAmountAndQuantityResponse,
  BusinessReportGeneralMetrics,
  BusinessReportNetSalesTimeseriesResponse,
  BusinessReportOrderSourcesNetSalesResponse,
  BusinessReportOrderTagsNetSalesResponse,
  BusinessReportOrderTypesNetSalesResponse,
  BusinessReportPaymentMethodsNetAmountResponse,
  ChangeBusinessContextRequest,
  ChangeModeRequest,
  ChangePasswordRequest,
  CreateSEmbedSessionRequest,
  Currency,
  CustomerSuccessInfo,
  DemoLoginRequest,
  ExtendedOrder,
  FeatureFlagResponse,
  GetBusinessesResponse,
  GetInactiveFoodicsUsersResponse,
  GetThoughtspotDataSourcesResponse,
  GetThoughtspotLiveboardsResponse,
  GetThoughtspotSchedulesResponse,
  GetUsersByBusinessResponse,
  GetUsersByOrganizationResponse,
  ImpersonateResponse,
  InviteFoodicsAccountsRequest,
  InvoicesCumulativeInfo,
  Licenses,
  LiveboardCategory,
  LoginRequest,
  LoginResponse,
  MenuMixBranchProductsWithNetSalesAndQuantityListResponse,
  MenuMixBusinessBranchesWithQuantityResponse,
  MenuMixBusinessProductBranchesWithNetSalesAndQuantityResponse,
  MenuMixBusinessProductCategoriesWithNetSalesListResponse,
  MenuMixBusinessProductCategoryBranchesWithNetSalesResponse,
  MenuMixBusinessProductCategoryOrderTagsWithNetSalesResponse,
  MenuMixBusinessProductOrderTagsWithNetSalesAndQuantityResponse,
  MenuMixBusinessProductsQuantityTimeseriesResponse,
  MenuMixBusinessProductsWithNetSalesAndQuantityListResponse,
  MenuMixProductsOrderBy,
  MiniAppBusinessSessionResponse,
  MiniAppLicensingResponse,
  MiniAppTokenExchangeActionResponse,
  MobileImpersonatorResponse,
  OrdersListFilterOptionsResponse,
  OrdersListResponse,
  OrdersOrderBy,
  OrganizationUsersSyncResponse,
  ProfileInvoicesResponse,
  ProfileSupportTicketsResponse,
  RequestOTPChallengeRequest,
  RequestOTPChallengeResponse,
  RequestResetPasswordRequest,
  RequestResetPasswordResponse,
  ResetPasswordRequest,
  SEmbedSessionResponse,
  StatusResponse,
  ThoughtspotLiveboardsCreateResponse,
  ThoughtspotToken,
  Timezone,
  Token,
  UpdateBusinessRequest,
  UserAggregate,
  VerifyOTPChallengeRequest,
  VerifyOTPChallengeResponse,
  WebAppPrivileges,
} from '../models/index';
import {
    AccountCumulativeInfoFromJSON,
    AccountCumulativeInfoToJSON,
    AddBusinessOTPRequestFromJSON,
    AddBusinessOTPRequestToJSON,
    AddBusinessOTPResponseFromJSON,
    AddBusinessOTPResponseToJSON,
    AdminLoginRequestFromJSON,
    AdminLoginRequestToJSON,
    AdminLoginResponseFromJSON,
    AdminLoginResponseToJSON,
    BranchAppsNetSalesResponseFromJSON,
    BranchAppsNetSalesResponseToJSON,
    BranchGeneralMetricsFromJSON,
    BranchGeneralMetricsToJSON,
    BranchNetSalesTimeseriesResponseFromJSON,
    BranchNetSalesTimeseriesResponseToJSON,
    BranchOrderSourcesNetSalesResponseFromJSON,
    BranchOrderSourcesNetSalesResponseToJSON,
    BranchOrderTagsNetSalesResponseFromJSON,
    BranchOrderTagsNetSalesResponseToJSON,
    BranchOrderTypesNetSalesResponseFromJSON,
    BranchOrderTypesNetSalesResponseToJSON,
    BranchPaymentMethodsNetAmountResponseFromJSON,
    BranchPaymentMethodsNetAmountResponseToJSON,
    BranchesNetSalesTimeseriesResponseFromJSON,
    BranchesNetSalesTimeseriesResponseToJSON,
    BranchesReportResponseFromJSON,
    BranchesReportResponseToJSON,
    BudgetResponseFromJSON,
    BudgetResponseToJSON,
    BudgetValidationErrorResponseFromJSON,
    BudgetValidationErrorResponseToJSON,
    BusinessFromJSON,
    BusinessToJSON,
    BusinessInfoFromJSON,
    BusinessInfoToJSON,
    BusinessInstallationStatusResponseFromJSON,
    BusinessInstallationStatusResponseToJSON,
    BusinessReportAppsNetSalesResponseFromJSON,
    BusinessReportAppsNetSalesResponseToJSON,
    BusinessReportBranchesOrderByFromJSON,
    BusinessReportBranchesOrderByToJSON,
    BusinessReportBranchesWithDiscountAmountAndQuantityResponseFromJSON,
    BusinessReportBranchesWithDiscountAmountAndQuantityResponseToJSON,
    BusinessReportBranchesWithNetAmountPerPaymentMethodResponseFromJSON,
    BusinessReportBranchesWithNetAmountPerPaymentMethodResponseToJSON,
    BusinessReportBranchesWithNetSalesAndOrderCountPerMarketplaceAppResponseFromJSON,
    BusinessReportBranchesWithNetSalesAndOrderCountPerMarketplaceAppResponseToJSON,
    BusinessReportBranchesWithNetSalesAndOrderCountPerOrderSourceResponseFromJSON,
    BusinessReportBranchesWithNetSalesAndOrderCountPerOrderSourceResponseToJSON,
    BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTagResponseFromJSON,
    BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTagResponseToJSON,
    BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTypeResponseFromJSON,
    BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTypeResponseToJSON,
    BusinessReportBranchesWithNetSalesPerOrderAndOrderCountResponseFromJSON,
    BusinessReportBranchesWithNetSalesPerOrderAndOrderCountResponseToJSON,
    BusinessReportBranchesWithOrderCountAndNetSalesResponseFromJSON,
    BusinessReportBranchesWithOrderCountAndNetSalesResponseToJSON,
    BusinessReportBranchesWithVoidAmountAndQuantityResponseFromJSON,
    BusinessReportBranchesWithVoidAmountAndQuantityResponseToJSON,
    BusinessReportGeneralMetricsFromJSON,
    BusinessReportGeneralMetricsToJSON,
    BusinessReportNetSalesTimeseriesResponseFromJSON,
    BusinessReportNetSalesTimeseriesResponseToJSON,
    BusinessReportOrderSourcesNetSalesResponseFromJSON,
    BusinessReportOrderSourcesNetSalesResponseToJSON,
    BusinessReportOrderTagsNetSalesResponseFromJSON,
    BusinessReportOrderTagsNetSalesResponseToJSON,
    BusinessReportOrderTypesNetSalesResponseFromJSON,
    BusinessReportOrderTypesNetSalesResponseToJSON,
    BusinessReportPaymentMethodsNetAmountResponseFromJSON,
    BusinessReportPaymentMethodsNetAmountResponseToJSON,
    ChangeBusinessContextRequestFromJSON,
    ChangeBusinessContextRequestToJSON,
    ChangeModeRequestFromJSON,
    ChangeModeRequestToJSON,
    ChangePasswordRequestFromJSON,
    ChangePasswordRequestToJSON,
    CreateSEmbedSessionRequestFromJSON,
    CreateSEmbedSessionRequestToJSON,
    CurrencyFromJSON,
    CurrencyToJSON,
    CustomerSuccessInfoFromJSON,
    CustomerSuccessInfoToJSON,
    DemoLoginRequestFromJSON,
    DemoLoginRequestToJSON,
    ExtendedOrderFromJSON,
    ExtendedOrderToJSON,
    FeatureFlagResponseFromJSON,
    FeatureFlagResponseToJSON,
    GetBusinessesResponseFromJSON,
    GetBusinessesResponseToJSON,
    GetInactiveFoodicsUsersResponseFromJSON,
    GetInactiveFoodicsUsersResponseToJSON,
    GetThoughtspotDataSourcesResponseFromJSON,
    GetThoughtspotDataSourcesResponseToJSON,
    GetThoughtspotLiveboardsResponseFromJSON,
    GetThoughtspotLiveboardsResponseToJSON,
    GetThoughtspotSchedulesResponseFromJSON,
    GetThoughtspotSchedulesResponseToJSON,
    GetUsersByBusinessResponseFromJSON,
    GetUsersByBusinessResponseToJSON,
    GetUsersByOrganizationResponseFromJSON,
    GetUsersByOrganizationResponseToJSON,
    ImpersonateResponseFromJSON,
    ImpersonateResponseToJSON,
    InviteFoodicsAccountsRequestFromJSON,
    InviteFoodicsAccountsRequestToJSON,
    InvoicesCumulativeInfoFromJSON,
    InvoicesCumulativeInfoToJSON,
    LicensesFromJSON,
    LicensesToJSON,
    LiveboardCategoryFromJSON,
    LiveboardCategoryToJSON,
    LoginRequestFromJSON,
    LoginRequestToJSON,
    LoginResponseFromJSON,
    LoginResponseToJSON,
    MenuMixBranchProductsWithNetSalesAndQuantityListResponseFromJSON,
    MenuMixBranchProductsWithNetSalesAndQuantityListResponseToJSON,
    MenuMixBusinessBranchesWithQuantityResponseFromJSON,
    MenuMixBusinessBranchesWithQuantityResponseToJSON,
    MenuMixBusinessProductBranchesWithNetSalesAndQuantityResponseFromJSON,
    MenuMixBusinessProductBranchesWithNetSalesAndQuantityResponseToJSON,
    MenuMixBusinessProductCategoriesWithNetSalesListResponseFromJSON,
    MenuMixBusinessProductCategoriesWithNetSalesListResponseToJSON,
    MenuMixBusinessProductCategoryBranchesWithNetSalesResponseFromJSON,
    MenuMixBusinessProductCategoryBranchesWithNetSalesResponseToJSON,
    MenuMixBusinessProductCategoryOrderTagsWithNetSalesResponseFromJSON,
    MenuMixBusinessProductCategoryOrderTagsWithNetSalesResponseToJSON,
    MenuMixBusinessProductOrderTagsWithNetSalesAndQuantityResponseFromJSON,
    MenuMixBusinessProductOrderTagsWithNetSalesAndQuantityResponseToJSON,
    MenuMixBusinessProductsQuantityTimeseriesResponseFromJSON,
    MenuMixBusinessProductsQuantityTimeseriesResponseToJSON,
    MenuMixBusinessProductsWithNetSalesAndQuantityListResponseFromJSON,
    MenuMixBusinessProductsWithNetSalesAndQuantityListResponseToJSON,
    MenuMixProductsOrderByFromJSON,
    MenuMixProductsOrderByToJSON,
    MiniAppBusinessSessionResponseFromJSON,
    MiniAppBusinessSessionResponseToJSON,
    MiniAppLicensingResponseFromJSON,
    MiniAppLicensingResponseToJSON,
    MiniAppTokenExchangeActionResponseFromJSON,
    MiniAppTokenExchangeActionResponseToJSON,
    MobileImpersonatorResponseFromJSON,
    MobileImpersonatorResponseToJSON,
    OrdersListFilterOptionsResponseFromJSON,
    OrdersListFilterOptionsResponseToJSON,
    OrdersListResponseFromJSON,
    OrdersListResponseToJSON,
    OrdersOrderByFromJSON,
    OrdersOrderByToJSON,
    OrganizationUsersSyncResponseFromJSON,
    OrganizationUsersSyncResponseToJSON,
    ProfileInvoicesResponseFromJSON,
    ProfileInvoicesResponseToJSON,
    ProfileSupportTicketsResponseFromJSON,
    ProfileSupportTicketsResponseToJSON,
    RequestOTPChallengeRequestFromJSON,
    RequestOTPChallengeRequestToJSON,
    RequestOTPChallengeResponseFromJSON,
    RequestOTPChallengeResponseToJSON,
    RequestResetPasswordRequestFromJSON,
    RequestResetPasswordRequestToJSON,
    RequestResetPasswordResponseFromJSON,
    RequestResetPasswordResponseToJSON,
    ResetPasswordRequestFromJSON,
    ResetPasswordRequestToJSON,
    SEmbedSessionResponseFromJSON,
    SEmbedSessionResponseToJSON,
    StatusResponseFromJSON,
    StatusResponseToJSON,
    ThoughtspotLiveboardsCreateResponseFromJSON,
    ThoughtspotLiveboardsCreateResponseToJSON,
    ThoughtspotTokenFromJSON,
    ThoughtspotTokenToJSON,
    TimezoneFromJSON,
    TimezoneToJSON,
    TokenFromJSON,
    TokenToJSON,
    UpdateBusinessRequestFromJSON,
    UpdateBusinessRequestToJSON,
    UserAggregateFromJSON,
    UserAggregateToJSON,
    VerifyOTPChallengeRequestFromJSON,
    VerifyOTPChallengeRequestToJSON,
    VerifyOTPChallengeResponseFromJSON,
    VerifyOTPChallengeResponseToJSON,
    WebAppPrivilegesFromJSON,
    WebAppPrivilegesToJSON,
} from '../models/index';

export interface CreateSEmbedSessionOperationRequest {
    CreateSEmbedSessionRequest: CreateSEmbedSessionRequest;
}

export interface DeleteThoughtspotCustomLiveboardsRequest {
    liveboard_id: string;
}

export interface FavoriteThoughtspotLiveboardRequest {
    liveboard_id: string;
}

export interface GetBranchAppsNetSalesRequest {
    branch_id: string;
    time_period?: GetBranchAppsNetSalesTimePeriodEnum;
    date_range_start?: Date;
    date_range_end?: Date;
}

export interface GetBranchGeneralMetricsRequest {
    branch_id: string;
    time_period?: GetBranchGeneralMetricsTimePeriodEnum;
    date_range_start?: Date;
    date_range_end?: Date;
}

export interface GetBranchNetSalesTimeseriesRequest {
    branch_id: string;
    time_period?: GetBranchNetSalesTimeseriesTimePeriodEnum;
    date_range_start?: Date;
    date_range_end?: Date;
}

export interface GetBranchOrderSourcesNetSalesRequest {
    branch_id: string;
    time_period?: GetBranchOrderSourcesNetSalesTimePeriodEnum;
    date_range_start?: Date;
    date_range_end?: Date;
}

export interface GetBranchOrderTagsNetSalesRequest {
    branch_id: string;
    time_period?: GetBranchOrderTagsNetSalesTimePeriodEnum;
    date_range_start?: Date;
    date_range_end?: Date;
}

export interface GetBranchOrderTypesNetSalesRequest {
    branch_id: string;
    time_period?: GetBranchOrderTypesNetSalesTimePeriodEnum;
    date_range_start?: Date;
    date_range_end?: Date;
}

export interface GetBranchPaymentMethodsNetAmountRequest {
    branch_id: string;
    time_period?: GetBranchPaymentMethodsNetAmountTimePeriodEnum;
    date_range_start?: Date;
    date_range_end?: Date;
}

export interface GetBranchesNetSalesTimeseriesRequest {
    business_id: string;
    time_period?: GetBranchesNetSalesTimeseriesTimePeriodEnum;
    date_range_start?: Date;
    date_range_end?: Date;
}

export interface GetBranchesReportRequest {
    business_id: string;
    time_period?: GetBranchesReportTimePeriodEnum;
    date_range_start?: Date;
    date_range_end?: Date;
}

export interface GetBudgetRequest {
    business_id: string;
    resolution: GetBudgetResolutionEnum;
    year: number;
}

export interface GetBudgetTemplateRequest {
    business_id: string;
    resolution: GetBudgetTemplateResolutionEnum;
    year: number;
}

export interface GetBudgetXlsxRequest {
    business_id: string;
    resolution: GetBudgetXlsxResolutionEnum;
    year: number;
}

export interface GetBusinessAppsNetSalesRequest {
    business_id: string;
    time_period?: GetBusinessAppsNetSalesTimePeriodEnum;
    date_range_start?: Date;
    date_range_end?: Date;
}

export interface GetBusinessBranchesWithDiscountAmountAndQuantityRequest {
    business_id: string;
    time_period?: GetBusinessBranchesWithDiscountAmountAndQuantityTimePeriodEnum;
    date_range_start?: Date;
    date_range_end?: Date;
}

export interface GetBusinessBranchesWithNetAmountPerPaymentMethodRequest {
    business_id: string;
    time_period?: GetBusinessBranchesWithNetAmountPerPaymentMethodTimePeriodEnum;
    date_range_start?: Date;
    date_range_end?: Date;
}

export interface GetBusinessBranchesWithNetSalesAndOrderCountPerMarketplaceAppRequest {
    business_id: string;
    time_period?: GetBusinessBranchesWithNetSalesAndOrderCountPerMarketplaceAppTimePeriodEnum;
    date_range_start?: Date;
    date_range_end?: Date;
}

export interface GetBusinessBranchesWithNetSalesAndOrderCountPerOrderSourceRequest {
    business_id: string;
    time_period?: GetBusinessBranchesWithNetSalesAndOrderCountPerOrderSourceTimePeriodEnum;
    date_range_start?: Date;
    date_range_end?: Date;
}

export interface GetBusinessBranchesWithNetSalesAndOrderCountPerOrderTagRequest {
    business_id: string;
    time_period?: GetBusinessBranchesWithNetSalesAndOrderCountPerOrderTagTimePeriodEnum;
    date_range_start?: Date;
    date_range_end?: Date;
}

export interface GetBusinessBranchesWithNetSalesAndOrderCountPerOrderTypeRequest {
    business_id: string;
    time_period?: GetBusinessBranchesWithNetSalesAndOrderCountPerOrderTypeTimePeriodEnum;
    date_range_start?: Date;
    date_range_end?: Date;
}

export interface GetBusinessBranchesWithNetSalesPerOrderAndOrderCountRequest {
    business_id: string;
    time_period?: GetBusinessBranchesWithNetSalesPerOrderAndOrderCountTimePeriodEnum;
    date_range_start?: Date;
    date_range_end?: Date;
}

export interface GetBusinessBranchesWithOrderCountAndNetSalesRequest {
    business_id: string;
    order_by: BusinessReportBranchesOrderBy;
    time_period?: GetBusinessBranchesWithOrderCountAndNetSalesTimePeriodEnum;
    date_range_start?: Date;
    date_range_end?: Date;
}

export interface GetBusinessBranchesWithVoidAmountAndQuantityRequest {
    business_id: string;
    time_period?: GetBusinessBranchesWithVoidAmountAndQuantityTimePeriodEnum;
    date_range_start?: Date;
    date_range_end?: Date;
}

export interface GetBusinessGeneralMetricsRequest {
    business_id: string;
    time_period?: GetBusinessGeneralMetricsTimePeriodEnum;
    date_range_start?: Date;
    date_range_end?: Date;
}

export interface GetBusinessInstallationStatusRequest {
    business_id: string;
}

export interface GetBusinessMiniappLicensingRequest {
    business_id: string;
}

export interface GetBusinessNetSalesTimeseriesRequest {
    business_id: string;
    time_period?: GetBusinessNetSalesTimeseriesTimePeriodEnum;
    date_range_start?: Date;
    date_range_end?: Date;
}

export interface GetBusinessOrderSourcesNetSalesRequest {
    business_id: string;
    time_period?: GetBusinessOrderSourcesNetSalesTimePeriodEnum;
    date_range_start?: Date;
    date_range_end?: Date;
}

export interface GetBusinessOrderTagsNetSalesRequest {
    business_id: string;
    time_period?: GetBusinessOrderTagsNetSalesTimePeriodEnum;
    date_range_start?: Date;
    date_range_end?: Date;
}

export interface GetBusinessOrderTypesNetSalesRequest {
    business_id: string;
    time_period?: GetBusinessOrderTypesNetSalesTimePeriodEnum;
    date_range_start?: Date;
    date_range_end?: Date;
}

export interface GetBusinessPaymentMethodsNetAmountRequest {
    business_id: string;
    time_period?: GetBusinessPaymentMethodsNetAmountTimePeriodEnum;
    date_range_start?: Date;
    date_range_end?: Date;
}

export interface GetFeatureFlagRequest {
    client_app: GetFeatureFlagClientAppEnum;
    feature_flag: GetFeatureFlagFeatureFlagEnum;
}

export interface GetInactiveUsersByBusinessRequest {
    business_id: string;
}

export interface GetMenuMixBranchProductsWithNetSalesAndQuantityRequest {
    branch_id: string;
    page: number;
    page_size: number;
    order_by: MenuMixProductsOrderBy;
    time_period?: GetMenuMixBranchProductsWithNetSalesAndQuantityTimePeriodEnum;
    date_range_start?: Date;
    date_range_end?: Date;
}

export interface GetMenuMixBusinessBranchesWithQuantityRequest {
    business_id: string;
    time_period?: GetMenuMixBusinessBranchesWithQuantityTimePeriodEnum;
    date_range_start?: Date;
    date_range_end?: Date;
}

export interface GetMenuMixBusinessProductBranchesWithNetSalesAndQuantityRequest {
    business_id: string;
    product_id: string;
    order_by: MenuMixProductsOrderBy;
    time_period?: GetMenuMixBusinessProductBranchesWithNetSalesAndQuantityTimePeriodEnum;
    date_range_start?: Date;
    date_range_end?: Date;
}

export interface GetMenuMixBusinessProductCategoriesWithNetSalesRequest {
    business_id: string;
    page: number;
    page_size: number;
    time_period?: GetMenuMixBusinessProductCategoriesWithNetSalesTimePeriodEnum;
    date_range_start?: Date;
    date_range_end?: Date;
}

export interface GetMenuMixBusinessProductCategoryBranchesWithNetSalesRequest {
    business_id: string;
    category_id: string;
    time_period?: GetMenuMixBusinessProductCategoryBranchesWithNetSalesTimePeriodEnum;
    date_range_start?: Date;
    date_range_end?: Date;
}

export interface GetMenuMixBusinessProductCategoryOrderTagsWithNetSalesRequest {
    business_id: string;
    category_id: string;
    time_period?: GetMenuMixBusinessProductCategoryOrderTagsWithNetSalesTimePeriodEnum;
    date_range_start?: Date;
    date_range_end?: Date;
}

export interface GetMenuMixBusinessProductOrderTagsWithNetSalesAndQuantityRequest {
    business_id: string;
    product_id: string;
    order_by: MenuMixProductsOrderBy;
    time_period?: GetMenuMixBusinessProductOrderTagsWithNetSalesAndQuantityTimePeriodEnum;
    date_range_start?: Date;
    date_range_end?: Date;
}

export interface GetMenuMixBusinessProductsQuantityTimeseriesRequest {
    business_id: string;
    time_period?: GetMenuMixBusinessProductsQuantityTimeseriesTimePeriodEnum;
    date_range_start?: Date;
    date_range_end?: Date;
}

export interface GetMenuMixBusinessProductsWithNetSalesAndQuantityRequest {
    business_id: string;
    page: number;
    page_size: number;
    order_by: MenuMixProductsOrderBy;
    time_period?: GetMenuMixBusinessProductsWithNetSalesAndQuantityTimePeriodEnum;
    date_range_start?: Date;
    date_range_end?: Date;
}

export interface GetOrdersBusinessListRequest {
    business_id: string;
    page: number;
    page_size: number;
    time_period?: GetOrdersBusinessListTimePeriodEnum;
    date_range_start?: Date;
    date_range_end?: Date;
    venue_ids?: Array<string>;
    order_tag_ids?: Array<string>;
    creator_ids?: Array<string>;
    order_by?: OrdersOrderBy;
}

export interface GetOrdersBusinessListFilterOptionsRequest {
    business_id: string;
    time_period?: GetOrdersBusinessListFilterOptionsTimePeriodEnum;
    date_range_start?: Date;
    date_range_end?: Date;
}

export interface GetOrdersBusinessVenueOrderRequest {
    business_id: string;
    venue_id: string;
    order_id: string;
}

export interface GetProfileBusinessAccountCumulativeInfoRequest {
    business_id: string;
}

export interface GetProfileBusinessCustomerSuccessRequest {
    business_id: string;
}

export interface GetProfileBusinessInfoRequest {
    business_id: string;
}

export interface GetProfileBusinessInvoicesRequest {
    business_id: string;
    page: number;
    page_size: number;
}

export interface GetProfileBusinessInvoicesCumulativeInfoRequest {
    business_id: string;
}

export interface GetProfileBusinessLicensesRequest {
    business_id: string;
}

export interface GetProfileBusinessSupportTicketsRequest {
    business_id: string;
    page: number;
    page_size: number;
}

export interface GetRefreshRequest {
    token: string;
}

export interface GetSettingsCurrencyRequest {
    business_id: string;
}

export interface GetSettingsTimezoneRequest {
    business_id: string;
}

export interface GetUsersByBusinessRequest {
    business_id: string;
}

export interface ImpersonateRequest {
    id: string;
}

export interface PatchBusinessesBusinessIdRequest {
    business_id: string;
    UpdateBusinessRequest?: UpdateBusinessRequest;
}

export interface PostBudgetRequest {
    business_id: string;
    year: number;
    body?: Blob;
}

export interface PostChangePasswordRequest {
    ChangePasswordRequest?: ChangePasswordRequest;
}

export interface PostInviteFoodicsAccountsRequest {
    business_id: string;
    InviteFoodicsAccountsRequest?: InviteFoodicsAccountsRequest;
}

export interface PostLoginRequest {
    LoginRequest?: LoginRequest;
}

export interface PostLoginDemoRequest {
    DemoLoginRequest: DemoLoginRequest;
}

export interface PostLoginOtpChallengeRequest {
    RequestOTPChallengeRequest: RequestOTPChallengeRequest;
}

export interface PostLoginOtpVerifyRequest {
    VerifyOTPChallengeRequest: VerifyOTPChallengeRequest;
}

export interface PostOpsLoginRequest {
    AdminLoginRequest?: AdminLoginRequest;
}

export interface PostOrganizationBusinessesOtpVerifyRequest {
    AddBusinessOTPRequest: AddBusinessOTPRequest;
}

export interface PostRequestResetPasswordRequest {
    RequestResetPasswordRequest?: RequestResetPasswordRequest;
}

export interface PostResetPasswordRequest {
    ResetPasswordRequest?: ResetPasswordRequest;
}

export interface PostSelfBusinessContextRequest {
    ChangeBusinessContextRequest?: ChangeBusinessContextRequest;
}

export interface PostSelfEnterpriseWebAppLiveboardsOrderRequest {
    LiveboardCategory?: Array<LiveboardCategory>;
}

export interface PostSelfEnterpriseWebAppModeRequest {
    ChangeModeRequest?: ChangeModeRequest;
}

export interface PostThoughtspotLiveboardsCreateRequest {
    liveboard_name: string;
}

export interface UnfavoriteThoughtspotLiveboardRequest {
    liveboard_id: string;
}

export interface UpdateUserWebAppPrivilegesRequest {
    user_id: string;
    body?: WebAppPrivileges;
}

export interface UsersPromoteUserRequest {
    user_id: string;
}

/**
 * DefaultApi - interface
 * 
 * @export
 * @interface DefaultApiInterface
 */
export interface DefaultApiInterface {
    /**
     * 
     * @summary Create an S embed session, optionally using the saved business selection for the full app
     * @param {CreateSEmbedSessionRequest} CreateSEmbedSessionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    createSEmbedSessionRaw(requestParameters: CreateSEmbedSessionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SEmbedSessionResponse>>;

    /**
     * Create an S embed session, optionally using the saved business selection for the full app
     */
    createSEmbedSession(requestParameters: CreateSEmbedSessionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SEmbedSessionResponse>;

    /**
     * 
     * @summary Delete custom thoughtspot liveboard
     * @param {string} liveboard_id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    deleteThoughtspotCustomLiveboardsRaw(requestParameters: DeleteThoughtspotCustomLiveboardsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete custom thoughtspot liveboard
     */
    deleteThoughtspotCustomLiveboards(requestParameters: DeleteThoughtspotCustomLiveboardsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Favorite thoughtspot liveboard to favorites
     * @param {string} liveboard_id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    favoriteThoughtspotLiveboardRaw(requestParameters: FavoriteThoughtspotLiveboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Favorite thoughtspot liveboard to favorites
     */
    favoriteThoughtspotLiveboard(requestParameters: FavoriteThoughtspotLiveboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get net sales per app
     * @param {string} branch_id 
     * @param {'today' | 'yesterday' | 'this-week' | 'last-week' | 'this-month' | 'last-month' | 'this-year'} [time_period] 
     * @param {Date} [date_range_start] 
     * @param {Date} [date_range_end] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getBranchAppsNetSalesRaw(requestParameters: GetBranchAppsNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BranchAppsNetSalesResponse>>;

    /**
     * Get net sales per app
     */
    getBranchAppsNetSales(requestParameters: GetBranchAppsNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BranchAppsNetSalesResponse>;

    /**
     * 
     * @summary Get general metrics of a branch
     * @param {string} branch_id 
     * @param {'today' | 'yesterday' | 'this-week' | 'last-week' | 'this-month' | 'last-month' | 'this-year'} [time_period] 
     * @param {Date} [date_range_start] 
     * @param {Date} [date_range_end] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getBranchGeneralMetricsRaw(requestParameters: GetBranchGeneralMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BranchGeneralMetrics>>;

    /**
     * Get general metrics of a branch
     */
    getBranchGeneralMetrics(requestParameters: GetBranchGeneralMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BranchGeneralMetrics>;

    /**
     * 
     * @summary Get net sales timeseries of a branch
     * @param {string} branch_id 
     * @param {'today' | 'yesterday' | 'this-week' | 'last-week' | 'this-month' | 'last-month' | 'this-year'} [time_period] 
     * @param {Date} [date_range_start] 
     * @param {Date} [date_range_end] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getBranchNetSalesTimeseriesRaw(requestParameters: GetBranchNetSalesTimeseriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BranchNetSalesTimeseriesResponse>>;

    /**
     * Get net sales timeseries of a branch
     */
    getBranchNetSalesTimeseries(requestParameters: GetBranchNetSalesTimeseriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BranchNetSalesTimeseriesResponse>;

    /**
     * 
     * @summary Get net sales per order source
     * @param {string} branch_id 
     * @param {'today' | 'yesterday' | 'this-week' | 'last-week' | 'this-month' | 'last-month' | 'this-year'} [time_period] 
     * @param {Date} [date_range_start] 
     * @param {Date} [date_range_end] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getBranchOrderSourcesNetSalesRaw(requestParameters: GetBranchOrderSourcesNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BranchOrderSourcesNetSalesResponse>>;

    /**
     * Get net sales per order source
     */
    getBranchOrderSourcesNetSales(requestParameters: GetBranchOrderSourcesNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BranchOrderSourcesNetSalesResponse>;

    /**
     * 
     * @summary Get net sales per order tag
     * @param {string} branch_id 
     * @param {'today' | 'yesterday' | 'this-week' | 'last-week' | 'this-month' | 'last-month' | 'this-year'} [time_period] 
     * @param {Date} [date_range_start] 
     * @param {Date} [date_range_end] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getBranchOrderTagsNetSalesRaw(requestParameters: GetBranchOrderTagsNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BranchOrderTagsNetSalesResponse>>;

    /**
     * Get net sales per order tag
     */
    getBranchOrderTagsNetSales(requestParameters: GetBranchOrderTagsNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BranchOrderTagsNetSalesResponse>;

    /**
     * 
     * @summary Get net sales per order type
     * @param {string} branch_id 
     * @param {'today' | 'yesterday' | 'this-week' | 'last-week' | 'this-month' | 'last-month' | 'this-year'} [time_period] 
     * @param {Date} [date_range_start] 
     * @param {Date} [date_range_end] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getBranchOrderTypesNetSalesRaw(requestParameters: GetBranchOrderTypesNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BranchOrderTypesNetSalesResponse>>;

    /**
     * Get net sales per order type
     */
    getBranchOrderTypesNetSales(requestParameters: GetBranchOrderTypesNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BranchOrderTypesNetSalesResponse>;

    /**
     * 
     * @summary Get net amount per payment method
     * @param {string} branch_id 
     * @param {'today' | 'yesterday' | 'this-week' | 'last-week' | 'this-month' | 'last-month' | 'this-year'} [time_period] 
     * @param {Date} [date_range_start] 
     * @param {Date} [date_range_end] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getBranchPaymentMethodsNetAmountRaw(requestParameters: GetBranchPaymentMethodsNetAmountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BranchPaymentMethodsNetAmountResponse>>;

    /**
     * Get net amount per payment method
     */
    getBranchPaymentMethodsNetAmount(requestParameters: GetBranchPaymentMethodsNetAmountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BranchPaymentMethodsNetAmountResponse>;

    /**
     * 
     * @summary Get net sales timeseries of user\'s branches
     * @param {string} business_id 
     * @param {'today' | 'yesterday' | 'this-week' | 'last-week' | 'this-month' | 'last-month' | 'this-year'} [time_period] 
     * @param {Date} [date_range_start] 
     * @param {Date} [date_range_end] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getBranchesNetSalesTimeseriesRaw(requestParameters: GetBranchesNetSalesTimeseriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BranchesNetSalesTimeseriesResponse>>;

    /**
     * Get net sales timeseries of user\'s branches
     */
    getBranchesNetSalesTimeseries(requestParameters: GetBranchesNetSalesTimeseriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BranchesNetSalesTimeseriesResponse>;

    /**
     * 
     * @summary Get report of user\'s branches by business
     * @param {string} business_id 
     * @param {'today' | 'yesterday' | 'this-week' | 'last-week' | 'this-month' | 'last-month' | 'this-year'} [time_period] 
     * @param {Date} [date_range_start] 
     * @param {Date} [date_range_end] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getBranchesReportRaw(requestParameters: GetBranchesReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BranchesReportResponse>>;

    /**
     * Get report of user\'s branches by business
     */
    getBranchesReport(requestParameters: GetBranchesReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BranchesReportResponse>;

    /**
     * 
     * @summary Get a budget
     * @param {string} business_id 
     * @param {'weekly' | 'monthly'} resolution 
     * @param {number} year 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getBudgetRaw(requestParameters: GetBudgetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BudgetResponse>>;

    /**
     * Get a budget
     */
    getBudget(requestParameters: GetBudgetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BudgetResponse>;

    /**
     * 
     * @summary Get a budget template file
     * @param {string} business_id 
     * @param {'weekly' | 'monthly'} resolution 
     * @param {number} year 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getBudgetTemplateRaw(requestParameters: GetBudgetTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>>;

    /**
     * Get a budget template file
     */
    getBudgetTemplate(requestParameters: GetBudgetTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob>;

    /**
     * 
     * @summary Get a budget in XLSX format
     * @param {string} business_id 
     * @param {'weekly' | 'monthly'} resolution 
     * @param {number} year 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getBudgetXlsxRaw(requestParameters: GetBudgetXlsxRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>>;

    /**
     * Get a budget in XLSX format
     */
    getBudgetXlsx(requestParameters: GetBudgetXlsxRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob>;

    /**
     * 
     * @summary Get net sales per app of business
     * @param {string} business_id 
     * @param {'today' | 'yesterday' | 'this-week' | 'last-week' | 'this-month' | 'last-month' | 'this-year'} [time_period] 
     * @param {Date} [date_range_start] 
     * @param {Date} [date_range_end] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getBusinessAppsNetSalesRaw(requestParameters: GetBusinessAppsNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessReportAppsNetSalesResponse>>;

    /**
     * Get net sales per app of business
     */
    getBusinessAppsNetSales(requestParameters: GetBusinessAppsNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessReportAppsNetSalesResponse>;

    /**
     * 
     * @summary Get branches of business with discount amount and quantity
     * @param {string} business_id 
     * @param {'today' | 'yesterday' | 'this-week' | 'last-week' | 'this-month' | 'last-month' | 'this-year'} [time_period] 
     * @param {Date} [date_range_start] 
     * @param {Date} [date_range_end] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getBusinessBranchesWithDiscountAmountAndQuantityRaw(requestParameters: GetBusinessBranchesWithDiscountAmountAndQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessReportBranchesWithDiscountAmountAndQuantityResponse>>;

    /**
     * Get branches of business with discount amount and quantity
     */
    getBusinessBranchesWithDiscountAmountAndQuantity(requestParameters: GetBusinessBranchesWithDiscountAmountAndQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessReportBranchesWithDiscountAmountAndQuantityResponse>;

    /**
     * 
     * @summary Get branches of business with net amount per payment method
     * @param {string} business_id 
     * @param {'today' | 'yesterday' | 'this-week' | 'last-week' | 'this-month' | 'last-month' | 'this-year'} [time_period] 
     * @param {Date} [date_range_start] 
     * @param {Date} [date_range_end] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getBusinessBranchesWithNetAmountPerPaymentMethodRaw(requestParameters: GetBusinessBranchesWithNetAmountPerPaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessReportBranchesWithNetAmountPerPaymentMethodResponse>>;

    /**
     * Get branches of business with net amount per payment method
     */
    getBusinessBranchesWithNetAmountPerPaymentMethod(requestParameters: GetBusinessBranchesWithNetAmountPerPaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessReportBranchesWithNetAmountPerPaymentMethodResponse>;

    /**
     * 
     * @summary Get branches of business with net sales and order count per marketplace app
     * @param {string} business_id 
     * @param {'today' | 'yesterday' | 'this-week' | 'last-week' | 'this-month' | 'last-month' | 'this-year'} [time_period] 
     * @param {Date} [date_range_start] 
     * @param {Date} [date_range_end] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getBusinessBranchesWithNetSalesAndOrderCountPerMarketplaceAppRaw(requestParameters: GetBusinessBranchesWithNetSalesAndOrderCountPerMarketplaceAppRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessReportBranchesWithNetSalesAndOrderCountPerMarketplaceAppResponse>>;

    /**
     * Get branches of business with net sales and order count per marketplace app
     */
    getBusinessBranchesWithNetSalesAndOrderCountPerMarketplaceApp(requestParameters: GetBusinessBranchesWithNetSalesAndOrderCountPerMarketplaceAppRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessReportBranchesWithNetSalesAndOrderCountPerMarketplaceAppResponse>;

    /**
     * 
     * @summary Get branches of business with net sales and order count per order source
     * @param {string} business_id 
     * @param {'today' | 'yesterday' | 'this-week' | 'last-week' | 'this-month' | 'last-month' | 'this-year'} [time_period] 
     * @param {Date} [date_range_start] 
     * @param {Date} [date_range_end] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getBusinessBranchesWithNetSalesAndOrderCountPerOrderSourceRaw(requestParameters: GetBusinessBranchesWithNetSalesAndOrderCountPerOrderSourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessReportBranchesWithNetSalesAndOrderCountPerOrderSourceResponse>>;

    /**
     * Get branches of business with net sales and order count per order source
     */
    getBusinessBranchesWithNetSalesAndOrderCountPerOrderSource(requestParameters: GetBusinessBranchesWithNetSalesAndOrderCountPerOrderSourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessReportBranchesWithNetSalesAndOrderCountPerOrderSourceResponse>;

    /**
     * 
     * @summary Get branches of business with net sales and order count per order tag
     * @param {string} business_id 
     * @param {'today' | 'yesterday' | 'this-week' | 'last-week' | 'this-month' | 'last-month' | 'this-year'} [time_period] 
     * @param {Date} [date_range_start] 
     * @param {Date} [date_range_end] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getBusinessBranchesWithNetSalesAndOrderCountPerOrderTagRaw(requestParameters: GetBusinessBranchesWithNetSalesAndOrderCountPerOrderTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTagResponse>>;

    /**
     * Get branches of business with net sales and order count per order tag
     */
    getBusinessBranchesWithNetSalesAndOrderCountPerOrderTag(requestParameters: GetBusinessBranchesWithNetSalesAndOrderCountPerOrderTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTagResponse>;

    /**
     * 
     * @summary Get branches of business with net sales and order count per order type
     * @param {string} business_id 
     * @param {'today' | 'yesterday' | 'this-week' | 'last-week' | 'this-month' | 'last-month' | 'this-year'} [time_period] 
     * @param {Date} [date_range_start] 
     * @param {Date} [date_range_end] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getBusinessBranchesWithNetSalesAndOrderCountPerOrderTypeRaw(requestParameters: GetBusinessBranchesWithNetSalesAndOrderCountPerOrderTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTypeResponse>>;

    /**
     * Get branches of business with net sales and order count per order type
     */
    getBusinessBranchesWithNetSalesAndOrderCountPerOrderType(requestParameters: GetBusinessBranchesWithNetSalesAndOrderCountPerOrderTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTypeResponse>;

    /**
     * 
     * @summary Get branches of business with net sales per order and order count
     * @param {string} business_id 
     * @param {'today' | 'yesterday' | 'this-week' | 'last-week' | 'this-month' | 'last-month' | 'this-year'} [time_period] 
     * @param {Date} [date_range_start] 
     * @param {Date} [date_range_end] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getBusinessBranchesWithNetSalesPerOrderAndOrderCountRaw(requestParameters: GetBusinessBranchesWithNetSalesPerOrderAndOrderCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessReportBranchesWithNetSalesPerOrderAndOrderCountResponse>>;

    /**
     * Get branches of business with net sales per order and order count
     */
    getBusinessBranchesWithNetSalesPerOrderAndOrderCount(requestParameters: GetBusinessBranchesWithNetSalesPerOrderAndOrderCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessReportBranchesWithNetSalesPerOrderAndOrderCountResponse>;

    /**
     * 
     * @summary Get branches of business with order count and net sales
     * @param {string} business_id 
     * @param {BusinessReportBranchesOrderBy} order_by 
     * @param {'today' | 'yesterday' | 'this-week' | 'last-week' | 'this-month' | 'last-month' | 'this-year'} [time_period] 
     * @param {Date} [date_range_start] 
     * @param {Date} [date_range_end] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getBusinessBranchesWithOrderCountAndNetSalesRaw(requestParameters: GetBusinessBranchesWithOrderCountAndNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessReportBranchesWithOrderCountAndNetSalesResponse>>;

    /**
     * Get branches of business with order count and net sales
     */
    getBusinessBranchesWithOrderCountAndNetSales(requestParameters: GetBusinessBranchesWithOrderCountAndNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessReportBranchesWithOrderCountAndNetSalesResponse>;

    /**
     * 
     * @summary Get branches of business with void amount and quantity
     * @param {string} business_id 
     * @param {'today' | 'yesterday' | 'this-week' | 'last-week' | 'this-month' | 'last-month' | 'this-year'} [time_period] 
     * @param {Date} [date_range_start] 
     * @param {Date} [date_range_end] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getBusinessBranchesWithVoidAmountAndQuantityRaw(requestParameters: GetBusinessBranchesWithVoidAmountAndQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessReportBranchesWithVoidAmountAndQuantityResponse>>;

    /**
     * Get branches of business with void amount and quantity
     */
    getBusinessBranchesWithVoidAmountAndQuantity(requestParameters: GetBusinessBranchesWithVoidAmountAndQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessReportBranchesWithVoidAmountAndQuantityResponse>;

    /**
     * 
     * @summary Get general metrics of a business
     * @param {string} business_id 
     * @param {'today' | 'yesterday' | 'this-week' | 'last-week' | 'this-month' | 'last-month' | 'this-year'} [time_period] 
     * @param {Date} [date_range_start] 
     * @param {Date} [date_range_end] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getBusinessGeneralMetricsRaw(requestParameters: GetBusinessGeneralMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessReportGeneralMetrics>>;

    /**
     * Get general metrics of a business
     */
    getBusinessGeneralMetrics(requestParameters: GetBusinessGeneralMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessReportGeneralMetrics>;

    /**
     * Checking an unfinished installation subscribes the authenticated user to a completion email.
     * @summary Check installation status for an accessible BI business
     * @param {string} business_id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getBusinessInstallationStatusRaw(requestParameters: GetBusinessInstallationStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessInstallationStatusResponse>>;

    /**
     * Checking an unfinished installation subscribes the authenticated user to a completion email.
     * Check installation status for an accessible BI business
     */
    getBusinessInstallationStatus(requestParameters: GetBusinessInstallationStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessInstallationStatusResponse>;

    /**
     * Separate from the business licensing the standalone apps use. A web_bi or app_bi addon licenses the miniapp with no end date; otherwise an active mobile or web grace period licenses it until the later grace date.
     * @summary Check whether the Foodics superapp miniapp opens for a business
     * @param {string} business_id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getBusinessMiniappLicensingRaw(requestParameters: GetBusinessMiniappLicensingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MiniAppLicensingResponse>>;

    /**
     * Separate from the business licensing the standalone apps use. A web_bi or app_bi addon licenses the miniapp with no end date; otherwise an active mobile or web grace period licenses it until the later grace date.
     * Check whether the Foodics superapp miniapp opens for a business
     */
    getBusinessMiniappLicensing(requestParameters: GetBusinessMiniappLicensingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MiniAppLicensingResponse>;

    /**
     * 
     * @summary Get net sales timeseries of a user\'s branches in a business
     * @param {string} business_id 
     * @param {'today' | 'yesterday' | 'this-week' | 'last-week' | 'this-month' | 'last-month' | 'this-year'} [time_period] 
     * @param {Date} [date_range_start] 
     * @param {Date} [date_range_end] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getBusinessNetSalesTimeseriesRaw(requestParameters: GetBusinessNetSalesTimeseriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessReportNetSalesTimeseriesResponse>>;

    /**
     * Get net sales timeseries of a user\'s branches in a business
     */
    getBusinessNetSalesTimeseries(requestParameters: GetBusinessNetSalesTimeseriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessReportNetSalesTimeseriesResponse>;

    /**
     * 
     * @summary Get net sales per order source of business
     * @param {string} business_id 
     * @param {'today' | 'yesterday' | 'this-week' | 'last-week' | 'this-month' | 'last-month' | 'this-year'} [time_period] 
     * @param {Date} [date_range_start] 
     * @param {Date} [date_range_end] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getBusinessOrderSourcesNetSalesRaw(requestParameters: GetBusinessOrderSourcesNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessReportOrderSourcesNetSalesResponse>>;

    /**
     * Get net sales per order source of business
     */
    getBusinessOrderSourcesNetSales(requestParameters: GetBusinessOrderSourcesNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessReportOrderSourcesNetSalesResponse>;

    /**
     * 
     * @summary Get net sales per order tag of business
     * @param {string} business_id 
     * @param {'today' | 'yesterday' | 'this-week' | 'last-week' | 'this-month' | 'last-month' | 'this-year'} [time_period] 
     * @param {Date} [date_range_start] 
     * @param {Date} [date_range_end] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getBusinessOrderTagsNetSalesRaw(requestParameters: GetBusinessOrderTagsNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessReportOrderTagsNetSalesResponse>>;

    /**
     * Get net sales per order tag of business
     */
    getBusinessOrderTagsNetSales(requestParameters: GetBusinessOrderTagsNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessReportOrderTagsNetSalesResponse>;

    /**
     * 
     * @summary Get net sales per order type of business
     * @param {string} business_id 
     * @param {'today' | 'yesterday' | 'this-week' | 'last-week' | 'this-month' | 'last-month' | 'this-year'} [time_period] 
     * @param {Date} [date_range_start] 
     * @param {Date} [date_range_end] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getBusinessOrderTypesNetSalesRaw(requestParameters: GetBusinessOrderTypesNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessReportOrderTypesNetSalesResponse>>;

    /**
     * Get net sales per order type of business
     */
    getBusinessOrderTypesNetSales(requestParameters: GetBusinessOrderTypesNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessReportOrderTypesNetSalesResponse>;

    /**
     * 
     * @summary Get net amount per payment method of business
     * @param {string} business_id 
     * @param {'today' | 'yesterday' | 'this-week' | 'last-week' | 'this-month' | 'last-month' | 'this-year'} [time_period] 
     * @param {Date} [date_range_start] 
     * @param {Date} [date_range_end] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getBusinessPaymentMethodsNetAmountRaw(requestParameters: GetBusinessPaymentMethodsNetAmountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessReportPaymentMethodsNetAmountResponse>>;

    /**
     * Get net amount per payment method of business
     */
    getBusinessPaymentMethodsNetAmount(requestParameters: GetBusinessPaymentMethodsNetAmountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessReportPaymentMethodsNetAmountResponse>;

    /**
     * 
     * @summary Get businesses of user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getBusinessesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBusinessesResponse>>;

    /**
     * Get businesses of user
     */
    getBusinesses(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBusinessesResponse>;

    /**
     * 
     * @summary Get a feature flag
     * @param {'web-app' | 'mobile-app'} client_app 
     * @param {'chat' | 'licensing' | 's_chat' | 's_full_app'} feature_flag 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getFeatureFlagRaw(requestParameters: GetFeatureFlagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FeatureFlagResponse>>;

    /**
     * Get a feature flag
     */
    getFeatureFlag(requestParameters: GetFeatureFlagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FeatureFlagResponse>;

    /**
     * 
     * @summary Get impersonator data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getImpersonatorDataRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MobileImpersonatorResponse>>;

    /**
     * Get impersonator data
     */
    getImpersonatorData(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MobileImpersonatorResponse>;

    /**
     * 
     * @summary Get inactive users by business
     * @param {string} business_id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getInactiveUsersByBusinessRaw(requestParameters: GetInactiveUsersByBusinessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetInactiveFoodicsUsersResponse>>;

    /**
     * Get inactive users by business
     */
    getInactiveUsersByBusiness(requestParameters: GetInactiveUsersByBusinessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetInactiveFoodicsUsersResponse>;

    /**
     * 
     * @summary Get a branch\'s products with net sales and quantity
     * @param {string} branch_id 
     * @param {number} page 
     * @param {number} page_size 
     * @param {MenuMixProductsOrderBy} order_by 
     * @param {'today' | 'yesterday' | 'this-week' | 'last-week' | 'this-month' | 'last-month' | 'this-year'} [time_period] 
     * @param {Date} [date_range_start] 
     * @param {Date} [date_range_end] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getMenuMixBranchProductsWithNetSalesAndQuantityRaw(requestParameters: GetMenuMixBranchProductsWithNetSalesAndQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MenuMixBranchProductsWithNetSalesAndQuantityListResponse>>;

    /**
     * Get a branch\'s products with net sales and quantity
     */
    getMenuMixBranchProductsWithNetSalesAndQuantity(requestParameters: GetMenuMixBranchProductsWithNetSalesAndQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MenuMixBranchProductsWithNetSalesAndQuantityListResponse>;

    /**
     * 
     * @summary Get a business\' branches with quantity
     * @param {string} business_id 
     * @param {'today' | 'yesterday' | 'this-week' | 'last-week' | 'this-month' | 'last-month' | 'this-year'} [time_period] 
     * @param {Date} [date_range_start] 
     * @param {Date} [date_range_end] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getMenuMixBusinessBranchesWithQuantityRaw(requestParameters: GetMenuMixBusinessBranchesWithQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MenuMixBusinessBranchesWithQuantityResponse>>;

    /**
     * Get a business\' branches with quantity
     */
    getMenuMixBusinessBranchesWithQuantity(requestParameters: GetMenuMixBusinessBranchesWithQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MenuMixBusinessBranchesWithQuantityResponse>;

    /**
     * 
     * @summary Get a business\' product branches with net sales and quantity
     * @param {string} business_id 
     * @param {string} product_id 
     * @param {MenuMixProductsOrderBy} order_by 
     * @param {'today' | 'yesterday' | 'this-week' | 'last-week' | 'this-month' | 'last-month' | 'this-year'} [time_period] 
     * @param {Date} [date_range_start] 
     * @param {Date} [date_range_end] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getMenuMixBusinessProductBranchesWithNetSalesAndQuantityRaw(requestParameters: GetMenuMixBusinessProductBranchesWithNetSalesAndQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MenuMixBusinessProductBranchesWithNetSalesAndQuantityResponse>>;

    /**
     * Get a business\' product branches with net sales and quantity
     */
    getMenuMixBusinessProductBranchesWithNetSalesAndQuantity(requestParameters: GetMenuMixBusinessProductBranchesWithNetSalesAndQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MenuMixBusinessProductBranchesWithNetSalesAndQuantityResponse>;

    /**
     * 
     * @summary Get a business\' product categories with net sales
     * @param {string} business_id 
     * @param {number} page 
     * @param {number} page_size 
     * @param {'today' | 'yesterday' | 'this-week' | 'last-week' | 'this-month' | 'last-month' | 'this-year'} [time_period] 
     * @param {Date} [date_range_start] 
     * @param {Date} [date_range_end] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getMenuMixBusinessProductCategoriesWithNetSalesRaw(requestParameters: GetMenuMixBusinessProductCategoriesWithNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MenuMixBusinessProductCategoriesWithNetSalesListResponse>>;

    /**
     * Get a business\' product categories with net sales
     */
    getMenuMixBusinessProductCategoriesWithNetSales(requestParameters: GetMenuMixBusinessProductCategoriesWithNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MenuMixBusinessProductCategoriesWithNetSalesListResponse>;

    /**
     * 
     * @summary Get a business\' product category branches with net sales
     * @param {string} business_id 
     * @param {string} category_id 
     * @param {'today' | 'yesterday' | 'this-week' | 'last-week' | 'this-month' | 'last-month' | 'this-year'} [time_period] 
     * @param {Date} [date_range_start] 
     * @param {Date} [date_range_end] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getMenuMixBusinessProductCategoryBranchesWithNetSalesRaw(requestParameters: GetMenuMixBusinessProductCategoryBranchesWithNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MenuMixBusinessProductCategoryBranchesWithNetSalesResponse>>;

    /**
     * Get a business\' product category branches with net sales
     */
    getMenuMixBusinessProductCategoryBranchesWithNetSales(requestParameters: GetMenuMixBusinessProductCategoryBranchesWithNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MenuMixBusinessProductCategoryBranchesWithNetSalesResponse>;

    /**
     * 
     * @summary Get a business\' product category order tags with net sales
     * @param {string} business_id 
     * @param {string} category_id 
     * @param {'today' | 'yesterday' | 'this-week' | 'last-week' | 'this-month' | 'last-month' | 'this-year'} [time_period] 
     * @param {Date} [date_range_start] 
     * @param {Date} [date_range_end] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getMenuMixBusinessProductCategoryOrderTagsWithNetSalesRaw(requestParameters: GetMenuMixBusinessProductCategoryOrderTagsWithNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MenuMixBusinessProductCategoryOrderTagsWithNetSalesResponse>>;

    /**
     * Get a business\' product category order tags with net sales
     */
    getMenuMixBusinessProductCategoryOrderTagsWithNetSales(requestParameters: GetMenuMixBusinessProductCategoryOrderTagsWithNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MenuMixBusinessProductCategoryOrderTagsWithNetSalesResponse>;

    /**
     * 
     * @summary Get a business\' product order tags with net sales and quantity
     * @param {string} business_id 
     * @param {string} product_id 
     * @param {MenuMixProductsOrderBy} order_by 
     * @param {'today' | 'yesterday' | 'this-week' | 'last-week' | 'this-month' | 'last-month' | 'this-year'} [time_period] 
     * @param {Date} [date_range_start] 
     * @param {Date} [date_range_end] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getMenuMixBusinessProductOrderTagsWithNetSalesAndQuantityRaw(requestParameters: GetMenuMixBusinessProductOrderTagsWithNetSalesAndQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MenuMixBusinessProductOrderTagsWithNetSalesAndQuantityResponse>>;

    /**
     * Get a business\' product order tags with net sales and quantity
     */
    getMenuMixBusinessProductOrderTagsWithNetSalesAndQuantity(requestParameters: GetMenuMixBusinessProductOrderTagsWithNetSalesAndQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MenuMixBusinessProductOrderTagsWithNetSalesAndQuantityResponse>;

    /**
     * 
     * @summary Get timeseries of a business\' products quantity sold
     * @param {string} business_id 
     * @param {'today' | 'yesterday' | 'this-week' | 'last-week' | 'this-month' | 'last-month' | 'this-year'} [time_period] 
     * @param {Date} [date_range_start] 
     * @param {Date} [date_range_end] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getMenuMixBusinessProductsQuantityTimeseriesRaw(requestParameters: GetMenuMixBusinessProductsQuantityTimeseriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MenuMixBusinessProductsQuantityTimeseriesResponse>>;

    /**
     * Get timeseries of a business\' products quantity sold
     */
    getMenuMixBusinessProductsQuantityTimeseries(requestParameters: GetMenuMixBusinessProductsQuantityTimeseriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MenuMixBusinessProductsQuantityTimeseriesResponse>;

    /**
     * 
     * @summary Get a business\' products with net sales and quantity
     * @param {string} business_id 
     * @param {number} page 
     * @param {number} page_size 
     * @param {MenuMixProductsOrderBy} order_by 
     * @param {'today' | 'yesterday' | 'this-week' | 'last-week' | 'this-month' | 'last-month' | 'this-year'} [time_period] 
     * @param {Date} [date_range_start] 
     * @param {Date} [date_range_end] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getMenuMixBusinessProductsWithNetSalesAndQuantityRaw(requestParameters: GetMenuMixBusinessProductsWithNetSalesAndQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MenuMixBusinessProductsWithNetSalesAndQuantityListResponse>>;

    /**
     * Get a business\' products with net sales and quantity
     */
    getMenuMixBusinessProductsWithNetSalesAndQuantity(requestParameters: GetMenuMixBusinessProductsWithNetSalesAndQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MenuMixBusinessProductsWithNetSalesAndQuantityListResponse>;

    /**
     * 
     * @summary Get an orders list of business
     * @param {string} business_id 
     * @param {number} page 
     * @param {number} page_size 
     * @param {'today' | 'yesterday' | 'this-week' | 'last-week' | 'this-month' | 'last-month' | 'this-year'} [time_period] 
     * @param {Date} [date_range_start] 
     * @param {Date} [date_range_end] 
     * @param {Array<string>} [venue_ids] 
     * @param {Array<string>} [order_tag_ids] 
     * @param {Array<string>} [creator_ids] 
     * @param {OrdersOrderBy} [order_by] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getOrdersBusinessListRaw(requestParameters: GetOrdersBusinessListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrdersListResponse>>;

    /**
     * Get an orders list of business
     */
    getOrdersBusinessList(requestParameters: GetOrdersBusinessListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrdersListResponse>;

    /**
     * 
     * @summary Get filter options for orders of business
     * @param {string} business_id 
     * @param {'today' | 'yesterday' | 'this-week' | 'last-week' | 'this-month' | 'last-month' | 'this-year'} [time_period] 
     * @param {Date} [date_range_start] 
     * @param {Date} [date_range_end] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getOrdersBusinessListFilterOptionsRaw(requestParameters: GetOrdersBusinessListFilterOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrdersListFilterOptionsResponse>>;

    /**
     * Get filter options for orders of business
     */
    getOrdersBusinessListFilterOptions(requestParameters: GetOrdersBusinessListFilterOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrdersListFilterOptionsResponse>;

    /**
     * 
     * @summary Get an extended order of business
     * @param {string} business_id 
     * @param {string} venue_id 
     * @param {string} order_id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getOrdersBusinessVenueOrderRaw(requestParameters: GetOrdersBusinessVenueOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExtendedOrder>>;

    /**
     * Get an extended order of business
     */
    getOrdersBusinessVenueOrder(requestParameters: GetOrdersBusinessVenueOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExtendedOrder>;

    /**
     * 
     * @summary Get the users of the logged in user\'s organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getOrganizationUsersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUsersByOrganizationResponse>>;

    /**
     * Get the users of the logged in user\'s organization
     */
    getOrganizationUsers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUsersByOrganizationResponse>;

    /**
     * 
     * @summary Get the current organization Foodics user sync status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getOrganizationUsersSyncRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationUsersSyncResponse>>;

    /**
     * Get the current organization Foodics user sync status
     */
    getOrganizationUsersSync(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationUsersSyncResponse>;

    /**
     * 
     * @summary Get cumulative info for the account of a business
     * @param {string} business_id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getProfileBusinessAccountCumulativeInfoRaw(requestParameters: GetProfileBusinessAccountCumulativeInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccountCumulativeInfo>>;

    /**
     * Get cumulative info for the account of a business
     */
    getProfileBusinessAccountCumulativeInfo(requestParameters: GetProfileBusinessAccountCumulativeInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccountCumulativeInfo>;

    /**
     * 
     * @summary Get customer success info of a business
     * @param {string} business_id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getProfileBusinessCustomerSuccessRaw(requestParameters: GetProfileBusinessCustomerSuccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerSuccessInfo>>;

    /**
     * Get customer success info of a business
     */
    getProfileBusinessCustomerSuccess(requestParameters: GetProfileBusinessCustomerSuccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerSuccessInfo>;

    /**
     * 
     * @summary Get general info for a business
     * @param {string} business_id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getProfileBusinessInfoRaw(requestParameters: GetProfileBusinessInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessInfo>>;

    /**
     * Get general info for a business
     */
    getProfileBusinessInfo(requestParameters: GetProfileBusinessInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessInfo>;

    /**
     * 
     * @summary Get the invoices of a business
     * @param {string} business_id 
     * @param {number} page 
     * @param {number} page_size 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getProfileBusinessInvoicesRaw(requestParameters: GetProfileBusinessInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProfileInvoicesResponse>>;

    /**
     * Get the invoices of a business
     */
    getProfileBusinessInvoices(requestParameters: GetProfileBusinessInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProfileInvoicesResponse>;

    /**
     * 
     * @summary Get cumulative info about invoices for a business
     * @param {string} business_id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getProfileBusinessInvoicesCumulativeInfoRaw(requestParameters: GetProfileBusinessInvoicesCumulativeInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvoicesCumulativeInfo>>;

    /**
     * Get cumulative info about invoices for a business
     */
    getProfileBusinessInvoicesCumulativeInfo(requestParameters: GetProfileBusinessInvoicesCumulativeInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvoicesCumulativeInfo>;

    /**
     * 
     * @summary Get the licenses of a business
     * @param {string} business_id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getProfileBusinessLicensesRaw(requestParameters: GetProfileBusinessLicensesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Licenses>>;

    /**
     * Get the licenses of a business
     */
    getProfileBusinessLicenses(requestParameters: GetProfileBusinessLicensesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Licenses>;

    /**
     * 
     * @summary Get support tickets of a business
     * @param {string} business_id 
     * @param {number} page 
     * @param {number} page_size 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getProfileBusinessSupportTicketsRaw(requestParameters: GetProfileBusinessSupportTicketsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProfileSupportTicketsResponse>>;

    /**
     * Get support tickets of a business
     */
    getProfileBusinessSupportTickets(requestParameters: GetProfileBusinessSupportTicketsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProfileSupportTicketsResponse>;

    /**
     * 
     * @summary Refresh auth
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getRefreshRaw(requestParameters: GetRefreshRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Token>>;

    /**
     * Refresh auth
     */
    getRefresh(requestParameters: GetRefreshRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Token>;

    /**
     * Update self
     * @summary Self endpoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getSelfRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserAggregate>>;

    /**
     * Update self
     * Self endpoint
     */
    getSelf(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserAggregate>;

    /**
     * 
     * @summary Get the currency of a business
     * @param {string} business_id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getSettingsCurrencyRaw(requestParameters: GetSettingsCurrencyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Currency>>;

    /**
     * Get the currency of a business
     */
    getSettingsCurrency(requestParameters: GetSettingsCurrencyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Currency>;

    /**
     * 
     * @summary Get the timezone of a business
     * @param {string} business_id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getSettingsTimezoneRaw(requestParameters: GetSettingsTimezoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Timezone>>;

    /**
     * Get the timezone of a business
     */
    getSettingsTimezone(requestParameters: GetSettingsTimezoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Timezone>;

    /**
     * 
     * @summary Returns information about the status of the biserver service
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StatusResponse>>;

    /**
     * Returns information about the status of the biserver service
     */
    getStatus(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StatusResponse>;

    /**
     * 
     * @summary Get custom thoughtspot liveboards
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getThoughtspotCustomLiveboardsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetThoughtspotLiveboardsResponse>>;

    /**
     * Get custom thoughtspot liveboards
     */
    getThoughtspotCustomLiveboards(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetThoughtspotLiveboardsResponse>;

    /**
     * 
     * @summary Get thoughtspot liveboards
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getThoughtspotLiveboardsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetThoughtspotLiveboardsResponse>>;

    /**
     * Get thoughtspot liveboards
     */
    getThoughtspotLiveboards(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetThoughtspotLiveboardsResponse>;

    /**
     * 
     * @summary Get thoughtspot schedules
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getThoughtspotSchedulesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetThoughtspotSchedulesResponse>>;

    /**
     * Get thoughtspot schedules
     */
    getThoughtspotSchedules(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetThoughtspotSchedulesResponse>;

    /**
     * 
     * @summary Get thoughtspot data sources for the search data feature
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getThoughtspotSearchDataDataSourcesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetThoughtspotDataSourcesResponse>>;

    /**
     * Get thoughtspot data sources for the search data feature
     */
    getThoughtspotSearchDataDataSources(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetThoughtspotDataSourcesResponse>;

    /**
     * 
     * @summary Get thoughtspot token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getThoughtspotTokenRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ThoughtspotToken>>;

    /**
     * Get thoughtspot token
     */
    getThoughtspotToken(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ThoughtspotToken>;

    /**
     * 
     * @summary Get users by business
     * @param {string} business_id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getUsersByBusinessRaw(requestParameters: GetUsersByBusinessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUsersByBusinessResponse>>;

    /**
     * Get users by business
     */
    getUsersByBusiness(requestParameters: GetUsersByBusinessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUsersByBusinessResponse>;

    /**
     * 
     * @summary Impersonate another user
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    impersonateRaw(requestParameters: ImpersonateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ImpersonateResponse>>;

    /**
     * Impersonate another user
     */
    impersonate(requestParameters: ImpersonateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ImpersonateResponse>;

    /**
     * 
     * @summary Update business
     * @param {string} business_id 
     * @param {UpdateBusinessRequest} [UpdateBusinessRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    patchBusinessesBusinessIdRaw(requestParameters: PatchBusinessesBusinessIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Business>>;

    /**
     * Update business
     */
    patchBusinessesBusinessId(requestParameters: PatchBusinessesBusinessIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Business>;

    /**
     * 
     * @summary Upload a budget file
     * @param {string} business_id 
     * @param {number} year 
     * @param {Blob} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    postBudgetRaw(requestParameters: PostBudgetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Upload a budget file
     */
    postBudget(requestParameters: PostBudgetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Change password
     * @param {ChangePasswordRequest} [ChangePasswordRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    postChangePasswordRaw(requestParameters: PostChangePasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Change password
     */
    postChangePassword(requestParameters: PostChangePasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Exchange a Foodics RMS session for a restricted host-business BI session
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    postFoodicsMiniappBusinessSessionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MiniAppBusinessSessionResponse>>;

    /**
     * Exchange a Foodics RMS session for a restricted host-business BI session
     */
    postFoodicsMiniappBusinessSession(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MiniAppBusinessSessionResponse>;

    /**
     * 
     * @summary Exchange a Foodics RMS session for a BI session
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    postFoodicsMiniappTokenExchangeRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoginResponse>>;

    /**
     * Exchange a Foodics RMS session for a BI session
     */
    postFoodicsMiniappTokenExchange(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoginResponse>;

    /**
     * 
     * @summary Email OTP login instructions to Foodics users in a business
     * @param {string} business_id 
     * @param {InviteFoodicsAccountsRequest} [InviteFoodicsAccountsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    postInviteFoodicsAccountsRaw(requestParameters: PostInviteFoodicsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Email OTP login instructions to Foodics users in a business
     */
    postInviteFoodicsAccounts(requestParameters: PostInviteFoodicsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {LoginRequest} [LoginRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    postLoginRaw(requestParameters: PostLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoginResponse>>;

    /**
     */
    postLogin(requestParameters: PostLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoginResponse>;

    /**
     * 
     * @summary Log in to an existing BI demo account without an email code
     * @param {DemoLoginRequest} DemoLoginRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    postLoginDemoRaw(requestParameters: PostLoginDemoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoginResponse>>;

    /**
     * Log in to an existing BI demo account without an email code
     */
    postLoginDemo(requestParameters: PostLoginDemoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoginResponse>;

    /**
     * 
     * @summary Request an email code for Foodics BI login
     * @param {RequestOTPChallengeRequest} RequestOTPChallengeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    postLoginOtpChallengeRaw(requestParameters: PostLoginOtpChallengeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RequestOTPChallengeResponse>>;

    /**
     * Request an email code for Foodics BI login
     */
    postLoginOtpChallenge(requestParameters: PostLoginOtpChallengeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RequestOTPChallengeResponse>;

    /**
     * 
     * @summary Verify an email code and log in
     * @param {VerifyOTPChallengeRequest} VerifyOTPChallengeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    postLoginOtpVerifyRaw(requestParameters: PostLoginOtpVerifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VerifyOTPChallengeResponse>>;

    /**
     * Verify an email code and log in
     */
    postLoginOtpVerify(requestParameters: PostLoginOtpVerifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VerifyOTPChallengeResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    postLogoutRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    postLogout(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {AdminLoginRequest} [AdminLoginRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    postOpsLoginRaw(requestParameters: PostOpsLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminLoginResponse>>;

    /**
     */
    postOpsLogin(requestParameters: PostOpsLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminLoginResponse>;

    /**
     * Verifies a code requested through /login/otp/challenge. An uninstalled business starts installation in this organization; an installed business moves here when the verified user is also a root in its current organization.
     * @summary Add a Foodics business to the signed-in root user\'s organization
     * @param {AddBusinessOTPRequest} AddBusinessOTPRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    postOrganizationBusinessesOtpVerifyRaw(requestParameters: PostOrganizationBusinessesOtpVerifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AddBusinessOTPResponse>>;

    /**
     * Verifies a code requested through /login/otp/challenge. An uninstalled business starts installation in this organization; an installed business moves here when the verified user is also a root in its current organization.
     * Add a Foodics business to the signed-in root user\'s organization
     */
    postOrganizationBusinessesOtpVerify(requestParameters: PostOrganizationBusinessesOtpVerifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AddBusinessOTPResponse>;

    /**
     * 
     * @summary Start a manual organization Foodics user sync when eligible
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    postOrganizationUsersSyncRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationUsersSyncResponse>>;

    /**
     * Start a manual organization Foodics user sync when eligible
     */
    postOrganizationUsersSync(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationUsersSyncResponse>;

    /**
     * 
     * @summary Request reset password
     * @param {RequestResetPasswordRequest} [RequestResetPasswordRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    postRequestResetPasswordRaw(requestParameters: PostRequestResetPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RequestResetPasswordResponse>>;

    /**
     * Request reset password
     */
    postRequestResetPassword(requestParameters: PostRequestResetPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RequestResetPasswordResponse>;

    /**
     * 
     * @summary Reset password
     * @param {ResetPasswordRequest} [ResetPasswordRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    postResetPasswordRaw(requestParameters: PostResetPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoginResponse>>;

    /**
     * Reset password
     */
    postResetPassword(requestParameters: PostResetPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoginResponse>;

    /**
     * 
     * @summary Change business context
     * @param {ChangeBusinessContextRequest} [ChangeBusinessContextRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    postSelfBusinessContextRaw(requestParameters: PostSelfBusinessContextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Change business context
     */
    postSelfBusinessContext(requestParameters: PostSelfBusinessContextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Change enterprise web app liveboards order
     * @param {Array<LiveboardCategory>} [LiveboardCategory] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    postSelfEnterpriseWebAppLiveboardsOrderRaw(requestParameters: PostSelfEnterpriseWebAppLiveboardsOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Change enterprise web app liveboards order
     */
    postSelfEnterpriseWebAppLiveboardsOrder(requestParameters: PostSelfEnterpriseWebAppLiveboardsOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Change enterprise web app mode
     * @param {ChangeModeRequest} [ChangeModeRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    postSelfEnterpriseWebAppModeRaw(requestParameters: PostSelfEnterpriseWebAppModeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Change enterprise web app mode
     */
    postSelfEnterpriseWebAppMode(requestParameters: PostSelfEnterpriseWebAppModeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Create a new liveboard
     * @param {string} liveboard_name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    postThoughtspotLiveboardsCreateRaw(requestParameters: PostThoughtspotLiveboardsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ThoughtspotLiveboardsCreateResponse>>;

    /**
     * Create a new liveboard
     */
    postThoughtspotLiveboardsCreate(requestParameters: PostThoughtspotLiveboardsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ThoughtspotLiveboardsCreateResponse>;

    /**
     * 
     * @summary Unfavorite thoughtspot liveboard
     * @param {string} liveboard_id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    unfavoriteThoughtspotLiveboardRaw(requestParameters: UnfavoriteThoughtspotLiveboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Unfavorite thoughtspot liveboard
     */
    unfavoriteThoughtspotLiveboard(requestParameters: UnfavoriteThoughtspotLiveboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Update a user\'s web app privileges
     * @param {string} user_id 
     * @param {WebAppPrivileges} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    updateUserWebAppPrivilegesRaw(requestParameters: UpdateUserWebAppPrivilegesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Update a user\'s web app privileges
     */
    updateUserWebAppPrivileges(requestParameters: UpdateUserWebAppPrivilegesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Promote user to admin
     * @param {string} user_id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    usersPromoteUserRaw(requestParameters: UsersPromoteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Promote user to admin
     */
    usersPromoteUser(requestParameters: UsersPromoteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI implements DefaultApiInterface {

    /**
     * Create an S embed session, optionally using the saved business selection for the full app
     */
    async createSEmbedSessionRaw(requestParameters: CreateSEmbedSessionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SEmbedSessionResponse>> {
        if (requestParameters['CreateSEmbedSessionRequest'] == null) {
            throw new runtime.RequiredError(
                'CreateSEmbedSessionRequest',
                'Required parameter "CreateSEmbedSessionRequest" was null or undefined when calling createSEmbedSession().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/s/embed-session`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateSEmbedSessionRequestToJSON(requestParameters['CreateSEmbedSessionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SEmbedSessionResponseFromJSON(jsonValue));
    }

    /**
     * Create an S embed session, optionally using the saved business selection for the full app
     */
    async createSEmbedSession(requestParameters: CreateSEmbedSessionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SEmbedSessionResponse> {
        const response = await this.createSEmbedSessionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete custom thoughtspot liveboard
     */
    async deleteThoughtspotCustomLiveboardsRaw(requestParameters: DeleteThoughtspotCustomLiveboardsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['liveboard_id'] == null) {
            throw new runtime.RequiredError(
                'liveboard_id',
                'Required parameter "liveboard_id" was null or undefined when calling deleteThoughtspotCustomLiveboards().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/integrations/thoughtspot/custom-liveboards/{liveboard_id}`.replace(`{${"liveboard_id"}}`, encodeURIComponent(String(requestParameters['liveboard_id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete custom thoughtspot liveboard
     */
    async deleteThoughtspotCustomLiveboards(requestParameters: DeleteThoughtspotCustomLiveboardsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteThoughtspotCustomLiveboardsRaw(requestParameters, initOverrides);
    }

    /**
     * Favorite thoughtspot liveboard to favorites
     */
    async favoriteThoughtspotLiveboardRaw(requestParameters: FavoriteThoughtspotLiveboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['liveboard_id'] == null) {
            throw new runtime.RequiredError(
                'liveboard_id',
                'Required parameter "liveboard_id" was null or undefined when calling favoriteThoughtspotLiveboard().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['liveboard_id'] != null) {
            queryParameters['liveboard_id'] = requestParameters['liveboard_id'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/integrations/thoughtspot/liveboards/favorite`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Favorite thoughtspot liveboard to favorites
     */
    async favoriteThoughtspotLiveboard(requestParameters: FavoriteThoughtspotLiveboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.favoriteThoughtspotLiveboardRaw(requestParameters, initOverrides);
    }

    /**
     * Get net sales per app
     */
    async getBranchAppsNetSalesRaw(requestParameters: GetBranchAppsNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BranchAppsNetSalesResponse>> {
        if (requestParameters['branch_id'] == null) {
            throw new runtime.RequiredError(
                'branch_id',
                'Required parameter "branch_id" was null or undefined when calling getBranchAppsNetSales().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['time_period'] != null) {
            queryParameters['time-period'] = requestParameters['time_period'];
        }

        if (requestParameters['date_range_start'] != null) {
            queryParameters['date-range-start'] = (requestParameters['date_range_start'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['date_range_end'] != null) {
            queryParameters['date-range-end'] = (requestParameters['date_range_end'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/branches-report/branches/{branch_id}/apps/net-sales`.replace(`{${"branch_id"}}`, encodeURIComponent(String(requestParameters['branch_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BranchAppsNetSalesResponseFromJSON(jsonValue));
    }

    /**
     * Get net sales per app
     */
    async getBranchAppsNetSales(requestParameters: GetBranchAppsNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BranchAppsNetSalesResponse> {
        const response = await this.getBranchAppsNetSalesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get general metrics of a branch
     */
    async getBranchGeneralMetricsRaw(requestParameters: GetBranchGeneralMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BranchGeneralMetrics>> {
        if (requestParameters['branch_id'] == null) {
            throw new runtime.RequiredError(
                'branch_id',
                'Required parameter "branch_id" was null or undefined when calling getBranchGeneralMetrics().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['time_period'] != null) {
            queryParameters['time-period'] = requestParameters['time_period'];
        }

        if (requestParameters['date_range_start'] != null) {
            queryParameters['date-range-start'] = (requestParameters['date_range_start'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['date_range_end'] != null) {
            queryParameters['date-range-end'] = (requestParameters['date_range_end'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/branches-report/branches/{branch_id}/general-metrics`.replace(`{${"branch_id"}}`, encodeURIComponent(String(requestParameters['branch_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BranchGeneralMetricsFromJSON(jsonValue));
    }

    /**
     * Get general metrics of a branch
     */
    async getBranchGeneralMetrics(requestParameters: GetBranchGeneralMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BranchGeneralMetrics> {
        const response = await this.getBranchGeneralMetricsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get net sales timeseries of a branch
     */
    async getBranchNetSalesTimeseriesRaw(requestParameters: GetBranchNetSalesTimeseriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BranchNetSalesTimeseriesResponse>> {
        if (requestParameters['branch_id'] == null) {
            throw new runtime.RequiredError(
                'branch_id',
                'Required parameter "branch_id" was null or undefined when calling getBranchNetSalesTimeseries().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['time_period'] != null) {
            queryParameters['time-period'] = requestParameters['time_period'];
        }

        if (requestParameters['date_range_start'] != null) {
            queryParameters['date-range-start'] = (requestParameters['date_range_start'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['date_range_end'] != null) {
            queryParameters['date-range-end'] = (requestParameters['date_range_end'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/branches-report/branches/{branch_id}/timeseries/net-sales`.replace(`{${"branch_id"}}`, encodeURIComponent(String(requestParameters['branch_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BranchNetSalesTimeseriesResponseFromJSON(jsonValue));
    }

    /**
     * Get net sales timeseries of a branch
     */
    async getBranchNetSalesTimeseries(requestParameters: GetBranchNetSalesTimeseriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BranchNetSalesTimeseriesResponse> {
        const response = await this.getBranchNetSalesTimeseriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get net sales per order source
     */
    async getBranchOrderSourcesNetSalesRaw(requestParameters: GetBranchOrderSourcesNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BranchOrderSourcesNetSalesResponse>> {
        if (requestParameters['branch_id'] == null) {
            throw new runtime.RequiredError(
                'branch_id',
                'Required parameter "branch_id" was null or undefined when calling getBranchOrderSourcesNetSales().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['time_period'] != null) {
            queryParameters['time-period'] = requestParameters['time_period'];
        }

        if (requestParameters['date_range_start'] != null) {
            queryParameters['date-range-start'] = (requestParameters['date_range_start'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['date_range_end'] != null) {
            queryParameters['date-range-end'] = (requestParameters['date_range_end'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/branches-report/branches/{branch_id}/order-sources/net-sales`.replace(`{${"branch_id"}}`, encodeURIComponent(String(requestParameters['branch_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BranchOrderSourcesNetSalesResponseFromJSON(jsonValue));
    }

    /**
     * Get net sales per order source
     */
    async getBranchOrderSourcesNetSales(requestParameters: GetBranchOrderSourcesNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BranchOrderSourcesNetSalesResponse> {
        const response = await this.getBranchOrderSourcesNetSalesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get net sales per order tag
     */
    async getBranchOrderTagsNetSalesRaw(requestParameters: GetBranchOrderTagsNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BranchOrderTagsNetSalesResponse>> {
        if (requestParameters['branch_id'] == null) {
            throw new runtime.RequiredError(
                'branch_id',
                'Required parameter "branch_id" was null or undefined when calling getBranchOrderTagsNetSales().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['time_period'] != null) {
            queryParameters['time-period'] = requestParameters['time_period'];
        }

        if (requestParameters['date_range_start'] != null) {
            queryParameters['date-range-start'] = (requestParameters['date_range_start'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['date_range_end'] != null) {
            queryParameters['date-range-end'] = (requestParameters['date_range_end'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/branches-report/branches/{branch_id}/order-tags/net-sales`.replace(`{${"branch_id"}}`, encodeURIComponent(String(requestParameters['branch_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BranchOrderTagsNetSalesResponseFromJSON(jsonValue));
    }

    /**
     * Get net sales per order tag
     */
    async getBranchOrderTagsNetSales(requestParameters: GetBranchOrderTagsNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BranchOrderTagsNetSalesResponse> {
        const response = await this.getBranchOrderTagsNetSalesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get net sales per order type
     */
    async getBranchOrderTypesNetSalesRaw(requestParameters: GetBranchOrderTypesNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BranchOrderTypesNetSalesResponse>> {
        if (requestParameters['branch_id'] == null) {
            throw new runtime.RequiredError(
                'branch_id',
                'Required parameter "branch_id" was null or undefined when calling getBranchOrderTypesNetSales().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['time_period'] != null) {
            queryParameters['time-period'] = requestParameters['time_period'];
        }

        if (requestParameters['date_range_start'] != null) {
            queryParameters['date-range-start'] = (requestParameters['date_range_start'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['date_range_end'] != null) {
            queryParameters['date-range-end'] = (requestParameters['date_range_end'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/branches-report/branches/{branch_id}/order-types/net-sales`.replace(`{${"branch_id"}}`, encodeURIComponent(String(requestParameters['branch_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BranchOrderTypesNetSalesResponseFromJSON(jsonValue));
    }

    /**
     * Get net sales per order type
     */
    async getBranchOrderTypesNetSales(requestParameters: GetBranchOrderTypesNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BranchOrderTypesNetSalesResponse> {
        const response = await this.getBranchOrderTypesNetSalesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get net amount per payment method
     */
    async getBranchPaymentMethodsNetAmountRaw(requestParameters: GetBranchPaymentMethodsNetAmountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BranchPaymentMethodsNetAmountResponse>> {
        if (requestParameters['branch_id'] == null) {
            throw new runtime.RequiredError(
                'branch_id',
                'Required parameter "branch_id" was null or undefined when calling getBranchPaymentMethodsNetAmount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['time_period'] != null) {
            queryParameters['time-period'] = requestParameters['time_period'];
        }

        if (requestParameters['date_range_start'] != null) {
            queryParameters['date-range-start'] = (requestParameters['date_range_start'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['date_range_end'] != null) {
            queryParameters['date-range-end'] = (requestParameters['date_range_end'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/branches-report/branches/{branch_id}/payment-methods/net-amount`.replace(`{${"branch_id"}}`, encodeURIComponent(String(requestParameters['branch_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BranchPaymentMethodsNetAmountResponseFromJSON(jsonValue));
    }

    /**
     * Get net amount per payment method
     */
    async getBranchPaymentMethodsNetAmount(requestParameters: GetBranchPaymentMethodsNetAmountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BranchPaymentMethodsNetAmountResponse> {
        const response = await this.getBranchPaymentMethodsNetAmountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get net sales timeseries of user\'s branches
     */
    async getBranchesNetSalesTimeseriesRaw(requestParameters: GetBranchesNetSalesTimeseriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BranchesNetSalesTimeseriesResponse>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling getBranchesNetSalesTimeseries().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['time_period'] != null) {
            queryParameters['time-period'] = requestParameters['time_period'];
        }

        if (requestParameters['date_range_start'] != null) {
            queryParameters['date-range-start'] = (requestParameters['date_range_start'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['date_range_end'] != null) {
            queryParameters['date-range-end'] = (requestParameters['date_range_end'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/branches-report/businesses/{business_id}/timeseries/net-sales`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BranchesNetSalesTimeseriesResponseFromJSON(jsonValue));
    }

    /**
     * Get net sales timeseries of user\'s branches
     */
    async getBranchesNetSalesTimeseries(requestParameters: GetBranchesNetSalesTimeseriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BranchesNetSalesTimeseriesResponse> {
        const response = await this.getBranchesNetSalesTimeseriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get report of user\'s branches by business
     */
    async getBranchesReportRaw(requestParameters: GetBranchesReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BranchesReportResponse>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling getBranchesReport().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['time_period'] != null) {
            queryParameters['time-period'] = requestParameters['time_period'];
        }

        if (requestParameters['date_range_start'] != null) {
            queryParameters['date-range-start'] = (requestParameters['date_range_start'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['date_range_end'] != null) {
            queryParameters['date-range-end'] = (requestParameters['date_range_end'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/branches-report/businesses/{business_id}`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BranchesReportResponseFromJSON(jsonValue));
    }

    /**
     * Get report of user\'s branches by business
     */
    async getBranchesReport(requestParameters: GetBranchesReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BranchesReportResponse> {
        const response = await this.getBranchesReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a budget
     */
    async getBudgetRaw(requestParameters: GetBudgetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BudgetResponse>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling getBudget().'
            );
        }

        if (requestParameters['resolution'] == null) {
            throw new runtime.RequiredError(
                'resolution',
                'Required parameter "resolution" was null or undefined when calling getBudget().'
            );
        }

        if (requestParameters['year'] == null) {
            throw new runtime.RequiredError(
                'year',
                'Required parameter "year" was null or undefined when calling getBudget().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['resolution'] != null) {
            queryParameters['resolution'] = requestParameters['resolution'];
        }

        if (requestParameters['year'] != null) {
            queryParameters['year'] = requestParameters['year'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/budget/{business_id}`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BudgetResponseFromJSON(jsonValue));
    }

    /**
     * Get a budget
     */
    async getBudget(requestParameters: GetBudgetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BudgetResponse> {
        const response = await this.getBudgetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a budget template file
     */
    async getBudgetTemplateRaw(requestParameters: GetBudgetTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling getBudgetTemplate().'
            );
        }

        if (requestParameters['resolution'] == null) {
            throw new runtime.RequiredError(
                'resolution',
                'Required parameter "resolution" was null or undefined when calling getBudgetTemplate().'
            );
        }

        if (requestParameters['year'] == null) {
            throw new runtime.RequiredError(
                'year',
                'Required parameter "year" was null or undefined when calling getBudgetTemplate().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['resolution'] != null) {
            queryParameters['resolution'] = requestParameters['resolution'];
        }

        if (requestParameters['year'] != null) {
            queryParameters['year'] = requestParameters['year'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/budget/{business_id}/template`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Get a budget template file
     */
    async getBudgetTemplate(requestParameters: GetBudgetTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getBudgetTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a budget in XLSX format
     */
    async getBudgetXlsxRaw(requestParameters: GetBudgetXlsxRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling getBudgetXlsx().'
            );
        }

        if (requestParameters['resolution'] == null) {
            throw new runtime.RequiredError(
                'resolution',
                'Required parameter "resolution" was null or undefined when calling getBudgetXlsx().'
            );
        }

        if (requestParameters['year'] == null) {
            throw new runtime.RequiredError(
                'year',
                'Required parameter "year" was null or undefined when calling getBudgetXlsx().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['resolution'] != null) {
            queryParameters['resolution'] = requestParameters['resolution'];
        }

        if (requestParameters['year'] != null) {
            queryParameters['year'] = requestParameters['year'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/budget/{business_id}/xlsx`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Get a budget in XLSX format
     */
    async getBudgetXlsx(requestParameters: GetBudgetXlsxRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getBudgetXlsxRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get net sales per app of business
     */
    async getBusinessAppsNetSalesRaw(requestParameters: GetBusinessAppsNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessReportAppsNetSalesResponse>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling getBusinessAppsNetSales().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['time_period'] != null) {
            queryParameters['time-period'] = requestParameters['time_period'];
        }

        if (requestParameters['date_range_start'] != null) {
            queryParameters['date-range-start'] = (requestParameters['date_range_start'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['date_range_end'] != null) {
            queryParameters['date-range-end'] = (requestParameters['date_range_end'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/business-report/business/{business_id}/apps/net-sales`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BusinessReportAppsNetSalesResponseFromJSON(jsonValue));
    }

    /**
     * Get net sales per app of business
     */
    async getBusinessAppsNetSales(requestParameters: GetBusinessAppsNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessReportAppsNetSalesResponse> {
        const response = await this.getBusinessAppsNetSalesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get branches of business with discount amount and quantity
     */
    async getBusinessBranchesWithDiscountAmountAndQuantityRaw(requestParameters: GetBusinessBranchesWithDiscountAmountAndQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessReportBranchesWithDiscountAmountAndQuantityResponse>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling getBusinessBranchesWithDiscountAmountAndQuantity().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['time_period'] != null) {
            queryParameters['time-period'] = requestParameters['time_period'];
        }

        if (requestParameters['date_range_start'] != null) {
            queryParameters['date-range-start'] = (requestParameters['date_range_start'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['date_range_end'] != null) {
            queryParameters['date-range-end'] = (requestParameters['date_range_end'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/business-report/business/{business_id}/branches/with-discount-amount-and-quantity`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BusinessReportBranchesWithDiscountAmountAndQuantityResponseFromJSON(jsonValue));
    }

    /**
     * Get branches of business with discount amount and quantity
     */
    async getBusinessBranchesWithDiscountAmountAndQuantity(requestParameters: GetBusinessBranchesWithDiscountAmountAndQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessReportBranchesWithDiscountAmountAndQuantityResponse> {
        const response = await this.getBusinessBranchesWithDiscountAmountAndQuantityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get branches of business with net amount per payment method
     */
    async getBusinessBranchesWithNetAmountPerPaymentMethodRaw(requestParameters: GetBusinessBranchesWithNetAmountPerPaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessReportBranchesWithNetAmountPerPaymentMethodResponse>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling getBusinessBranchesWithNetAmountPerPaymentMethod().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['time_period'] != null) {
            queryParameters['time-period'] = requestParameters['time_period'];
        }

        if (requestParameters['date_range_start'] != null) {
            queryParameters['date-range-start'] = (requestParameters['date_range_start'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['date_range_end'] != null) {
            queryParameters['date-range-end'] = (requestParameters['date_range_end'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/business-report/business/{business_id}/branches/with-net-amount/per-payment-method`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BusinessReportBranchesWithNetAmountPerPaymentMethodResponseFromJSON(jsonValue));
    }

    /**
     * Get branches of business with net amount per payment method
     */
    async getBusinessBranchesWithNetAmountPerPaymentMethod(requestParameters: GetBusinessBranchesWithNetAmountPerPaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessReportBranchesWithNetAmountPerPaymentMethodResponse> {
        const response = await this.getBusinessBranchesWithNetAmountPerPaymentMethodRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get branches of business with net sales and order count per marketplace app
     */
    async getBusinessBranchesWithNetSalesAndOrderCountPerMarketplaceAppRaw(requestParameters: GetBusinessBranchesWithNetSalesAndOrderCountPerMarketplaceAppRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessReportBranchesWithNetSalesAndOrderCountPerMarketplaceAppResponse>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling getBusinessBranchesWithNetSalesAndOrderCountPerMarketplaceApp().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['time_period'] != null) {
            queryParameters['time-period'] = requestParameters['time_period'];
        }

        if (requestParameters['date_range_start'] != null) {
            queryParameters['date-range-start'] = (requestParameters['date_range_start'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['date_range_end'] != null) {
            queryParameters['date-range-end'] = (requestParameters['date_range_end'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/business-report/business/{business_id}/branches/with-net-sales-and-order-count/per-marketplace-app`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BusinessReportBranchesWithNetSalesAndOrderCountPerMarketplaceAppResponseFromJSON(jsonValue));
    }

    /**
     * Get branches of business with net sales and order count per marketplace app
     */
    async getBusinessBranchesWithNetSalesAndOrderCountPerMarketplaceApp(requestParameters: GetBusinessBranchesWithNetSalesAndOrderCountPerMarketplaceAppRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessReportBranchesWithNetSalesAndOrderCountPerMarketplaceAppResponse> {
        const response = await this.getBusinessBranchesWithNetSalesAndOrderCountPerMarketplaceAppRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get branches of business with net sales and order count per order source
     */
    async getBusinessBranchesWithNetSalesAndOrderCountPerOrderSourceRaw(requestParameters: GetBusinessBranchesWithNetSalesAndOrderCountPerOrderSourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessReportBranchesWithNetSalesAndOrderCountPerOrderSourceResponse>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling getBusinessBranchesWithNetSalesAndOrderCountPerOrderSource().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['time_period'] != null) {
            queryParameters['time-period'] = requestParameters['time_period'];
        }

        if (requestParameters['date_range_start'] != null) {
            queryParameters['date-range-start'] = (requestParameters['date_range_start'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['date_range_end'] != null) {
            queryParameters['date-range-end'] = (requestParameters['date_range_end'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/business-report/business/{business_id}/branches/with-net-sales-and-order-count/per-order-source`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BusinessReportBranchesWithNetSalesAndOrderCountPerOrderSourceResponseFromJSON(jsonValue));
    }

    /**
     * Get branches of business with net sales and order count per order source
     */
    async getBusinessBranchesWithNetSalesAndOrderCountPerOrderSource(requestParameters: GetBusinessBranchesWithNetSalesAndOrderCountPerOrderSourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessReportBranchesWithNetSalesAndOrderCountPerOrderSourceResponse> {
        const response = await this.getBusinessBranchesWithNetSalesAndOrderCountPerOrderSourceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get branches of business with net sales and order count per order tag
     */
    async getBusinessBranchesWithNetSalesAndOrderCountPerOrderTagRaw(requestParameters: GetBusinessBranchesWithNetSalesAndOrderCountPerOrderTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTagResponse>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling getBusinessBranchesWithNetSalesAndOrderCountPerOrderTag().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['time_period'] != null) {
            queryParameters['time-period'] = requestParameters['time_period'];
        }

        if (requestParameters['date_range_start'] != null) {
            queryParameters['date-range-start'] = (requestParameters['date_range_start'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['date_range_end'] != null) {
            queryParameters['date-range-end'] = (requestParameters['date_range_end'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/business-report/business/{business_id}/branches/with-net-sales-and-order-count/per-order-tag`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTagResponseFromJSON(jsonValue));
    }

    /**
     * Get branches of business with net sales and order count per order tag
     */
    async getBusinessBranchesWithNetSalesAndOrderCountPerOrderTag(requestParameters: GetBusinessBranchesWithNetSalesAndOrderCountPerOrderTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTagResponse> {
        const response = await this.getBusinessBranchesWithNetSalesAndOrderCountPerOrderTagRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get branches of business with net sales and order count per order type
     */
    async getBusinessBranchesWithNetSalesAndOrderCountPerOrderTypeRaw(requestParameters: GetBusinessBranchesWithNetSalesAndOrderCountPerOrderTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTypeResponse>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling getBusinessBranchesWithNetSalesAndOrderCountPerOrderType().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['time_period'] != null) {
            queryParameters['time-period'] = requestParameters['time_period'];
        }

        if (requestParameters['date_range_start'] != null) {
            queryParameters['date-range-start'] = (requestParameters['date_range_start'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['date_range_end'] != null) {
            queryParameters['date-range-end'] = (requestParameters['date_range_end'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/business-report/business/{business_id}/branches/with-net-sales-and-order-count/per-order-type`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTypeResponseFromJSON(jsonValue));
    }

    /**
     * Get branches of business with net sales and order count per order type
     */
    async getBusinessBranchesWithNetSalesAndOrderCountPerOrderType(requestParameters: GetBusinessBranchesWithNetSalesAndOrderCountPerOrderTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTypeResponse> {
        const response = await this.getBusinessBranchesWithNetSalesAndOrderCountPerOrderTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get branches of business with net sales per order and order count
     */
    async getBusinessBranchesWithNetSalesPerOrderAndOrderCountRaw(requestParameters: GetBusinessBranchesWithNetSalesPerOrderAndOrderCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessReportBranchesWithNetSalesPerOrderAndOrderCountResponse>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling getBusinessBranchesWithNetSalesPerOrderAndOrderCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['time_period'] != null) {
            queryParameters['time-period'] = requestParameters['time_period'];
        }

        if (requestParameters['date_range_start'] != null) {
            queryParameters['date-range-start'] = (requestParameters['date_range_start'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['date_range_end'] != null) {
            queryParameters['date-range-end'] = (requestParameters['date_range_end'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/business-report/business/{business_id}/branches/with-net-sales-per-order-and-order-count`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BusinessReportBranchesWithNetSalesPerOrderAndOrderCountResponseFromJSON(jsonValue));
    }

    /**
     * Get branches of business with net sales per order and order count
     */
    async getBusinessBranchesWithNetSalesPerOrderAndOrderCount(requestParameters: GetBusinessBranchesWithNetSalesPerOrderAndOrderCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessReportBranchesWithNetSalesPerOrderAndOrderCountResponse> {
        const response = await this.getBusinessBranchesWithNetSalesPerOrderAndOrderCountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get branches of business with order count and net sales
     */
    async getBusinessBranchesWithOrderCountAndNetSalesRaw(requestParameters: GetBusinessBranchesWithOrderCountAndNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessReportBranchesWithOrderCountAndNetSalesResponse>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling getBusinessBranchesWithOrderCountAndNetSales().'
            );
        }

        if (requestParameters['order_by'] == null) {
            throw new runtime.RequiredError(
                'order_by',
                'Required parameter "order_by" was null or undefined when calling getBusinessBranchesWithOrderCountAndNetSales().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['time_period'] != null) {
            queryParameters['time-period'] = requestParameters['time_period'];
        }

        if (requestParameters['date_range_start'] != null) {
            queryParameters['date-range-start'] = (requestParameters['date_range_start'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['date_range_end'] != null) {
            queryParameters['date-range-end'] = (requestParameters['date_range_end'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['order_by'] != null) {
            queryParameters['order-by'] = requestParameters['order_by'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/business-report/business/{business_id}/branches/with-order-count-and-net-sales`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BusinessReportBranchesWithOrderCountAndNetSalesResponseFromJSON(jsonValue));
    }

    /**
     * Get branches of business with order count and net sales
     */
    async getBusinessBranchesWithOrderCountAndNetSales(requestParameters: GetBusinessBranchesWithOrderCountAndNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessReportBranchesWithOrderCountAndNetSalesResponse> {
        const response = await this.getBusinessBranchesWithOrderCountAndNetSalesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get branches of business with void amount and quantity
     */
    async getBusinessBranchesWithVoidAmountAndQuantityRaw(requestParameters: GetBusinessBranchesWithVoidAmountAndQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessReportBranchesWithVoidAmountAndQuantityResponse>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling getBusinessBranchesWithVoidAmountAndQuantity().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['time_period'] != null) {
            queryParameters['time-period'] = requestParameters['time_period'];
        }

        if (requestParameters['date_range_start'] != null) {
            queryParameters['date-range-start'] = (requestParameters['date_range_start'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['date_range_end'] != null) {
            queryParameters['date-range-end'] = (requestParameters['date_range_end'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/business-report/business/{business_id}/branches/with-void-amount-and-quantity`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BusinessReportBranchesWithVoidAmountAndQuantityResponseFromJSON(jsonValue));
    }

    /**
     * Get branches of business with void amount and quantity
     */
    async getBusinessBranchesWithVoidAmountAndQuantity(requestParameters: GetBusinessBranchesWithVoidAmountAndQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessReportBranchesWithVoidAmountAndQuantityResponse> {
        const response = await this.getBusinessBranchesWithVoidAmountAndQuantityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get general metrics of a business
     */
    async getBusinessGeneralMetricsRaw(requestParameters: GetBusinessGeneralMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessReportGeneralMetrics>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling getBusinessGeneralMetrics().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['time_period'] != null) {
            queryParameters['time-period'] = requestParameters['time_period'];
        }

        if (requestParameters['date_range_start'] != null) {
            queryParameters['date-range-start'] = (requestParameters['date_range_start'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['date_range_end'] != null) {
            queryParameters['date-range-end'] = (requestParameters['date_range_end'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/business-report/business/{business_id}/general-metrics`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BusinessReportGeneralMetricsFromJSON(jsonValue));
    }

    /**
     * Get general metrics of a business
     */
    async getBusinessGeneralMetrics(requestParameters: GetBusinessGeneralMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessReportGeneralMetrics> {
        const response = await this.getBusinessGeneralMetricsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Checking an unfinished installation subscribes the authenticated user to a completion email.
     * Check installation status for an accessible BI business
     */
    async getBusinessInstallationStatusRaw(requestParameters: GetBusinessInstallationStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessInstallationStatusResponse>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling getBusinessInstallationStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/businesses/{business_id}/installation-status`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BusinessInstallationStatusResponseFromJSON(jsonValue));
    }

    /**
     * Checking an unfinished installation subscribes the authenticated user to a completion email.
     * Check installation status for an accessible BI business
     */
    async getBusinessInstallationStatus(requestParameters: GetBusinessInstallationStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessInstallationStatusResponse> {
        const response = await this.getBusinessInstallationStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Separate from the business licensing the standalone apps use. A web_bi or app_bi addon licenses the miniapp with no end date; otherwise an active mobile or web grace period licenses it until the later grace date.
     * Check whether the Foodics superapp miniapp opens for a business
     */
    async getBusinessMiniappLicensingRaw(requestParameters: GetBusinessMiniappLicensingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MiniAppLicensingResponse>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling getBusinessMiniappLicensing().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/businesses/{business_id}/miniapp-licensing`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MiniAppLicensingResponseFromJSON(jsonValue));
    }

    /**
     * Separate from the business licensing the standalone apps use. A web_bi or app_bi addon licenses the miniapp with no end date; otherwise an active mobile or web grace period licenses it until the later grace date.
     * Check whether the Foodics superapp miniapp opens for a business
     */
    async getBusinessMiniappLicensing(requestParameters: GetBusinessMiniappLicensingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MiniAppLicensingResponse> {
        const response = await this.getBusinessMiniappLicensingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get net sales timeseries of a user\'s branches in a business
     */
    async getBusinessNetSalesTimeseriesRaw(requestParameters: GetBusinessNetSalesTimeseriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessReportNetSalesTimeseriesResponse>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling getBusinessNetSalesTimeseries().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['time_period'] != null) {
            queryParameters['time-period'] = requestParameters['time_period'];
        }

        if (requestParameters['date_range_start'] != null) {
            queryParameters['date-range-start'] = (requestParameters['date_range_start'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['date_range_end'] != null) {
            queryParameters['date-range-end'] = (requestParameters['date_range_end'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/business-report/business/{business_id}/timeseries/net-sales`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BusinessReportNetSalesTimeseriesResponseFromJSON(jsonValue));
    }

    /**
     * Get net sales timeseries of a user\'s branches in a business
     */
    async getBusinessNetSalesTimeseries(requestParameters: GetBusinessNetSalesTimeseriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessReportNetSalesTimeseriesResponse> {
        const response = await this.getBusinessNetSalesTimeseriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get net sales per order source of business
     */
    async getBusinessOrderSourcesNetSalesRaw(requestParameters: GetBusinessOrderSourcesNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessReportOrderSourcesNetSalesResponse>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling getBusinessOrderSourcesNetSales().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['time_period'] != null) {
            queryParameters['time-period'] = requestParameters['time_period'];
        }

        if (requestParameters['date_range_start'] != null) {
            queryParameters['date-range-start'] = (requestParameters['date_range_start'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['date_range_end'] != null) {
            queryParameters['date-range-end'] = (requestParameters['date_range_end'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/business-report/business/{business_id}/order-sources/net-sales`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BusinessReportOrderSourcesNetSalesResponseFromJSON(jsonValue));
    }

    /**
     * Get net sales per order source of business
     */
    async getBusinessOrderSourcesNetSales(requestParameters: GetBusinessOrderSourcesNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessReportOrderSourcesNetSalesResponse> {
        const response = await this.getBusinessOrderSourcesNetSalesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get net sales per order tag of business
     */
    async getBusinessOrderTagsNetSalesRaw(requestParameters: GetBusinessOrderTagsNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessReportOrderTagsNetSalesResponse>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling getBusinessOrderTagsNetSales().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['time_period'] != null) {
            queryParameters['time-period'] = requestParameters['time_period'];
        }

        if (requestParameters['date_range_start'] != null) {
            queryParameters['date-range-start'] = (requestParameters['date_range_start'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['date_range_end'] != null) {
            queryParameters['date-range-end'] = (requestParameters['date_range_end'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/business-report/business/{business_id}/order-tags/net-sales`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BusinessReportOrderTagsNetSalesResponseFromJSON(jsonValue));
    }

    /**
     * Get net sales per order tag of business
     */
    async getBusinessOrderTagsNetSales(requestParameters: GetBusinessOrderTagsNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessReportOrderTagsNetSalesResponse> {
        const response = await this.getBusinessOrderTagsNetSalesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get net sales per order type of business
     */
    async getBusinessOrderTypesNetSalesRaw(requestParameters: GetBusinessOrderTypesNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessReportOrderTypesNetSalesResponse>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling getBusinessOrderTypesNetSales().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['time_period'] != null) {
            queryParameters['time-period'] = requestParameters['time_period'];
        }

        if (requestParameters['date_range_start'] != null) {
            queryParameters['date-range-start'] = (requestParameters['date_range_start'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['date_range_end'] != null) {
            queryParameters['date-range-end'] = (requestParameters['date_range_end'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/business-report/business/{business_id}/order-types/net-sales`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BusinessReportOrderTypesNetSalesResponseFromJSON(jsonValue));
    }

    /**
     * Get net sales per order type of business
     */
    async getBusinessOrderTypesNetSales(requestParameters: GetBusinessOrderTypesNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessReportOrderTypesNetSalesResponse> {
        const response = await this.getBusinessOrderTypesNetSalesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get net amount per payment method of business
     */
    async getBusinessPaymentMethodsNetAmountRaw(requestParameters: GetBusinessPaymentMethodsNetAmountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessReportPaymentMethodsNetAmountResponse>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling getBusinessPaymentMethodsNetAmount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['time_period'] != null) {
            queryParameters['time-period'] = requestParameters['time_period'];
        }

        if (requestParameters['date_range_start'] != null) {
            queryParameters['date-range-start'] = (requestParameters['date_range_start'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['date_range_end'] != null) {
            queryParameters['date-range-end'] = (requestParameters['date_range_end'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/business-report/business/{business_id}/payment-methods/net-amount`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BusinessReportPaymentMethodsNetAmountResponseFromJSON(jsonValue));
    }

    /**
     * Get net amount per payment method of business
     */
    async getBusinessPaymentMethodsNetAmount(requestParameters: GetBusinessPaymentMethodsNetAmountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessReportPaymentMethodsNetAmountResponse> {
        const response = await this.getBusinessPaymentMethodsNetAmountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get businesses of user
     */
    async getBusinessesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBusinessesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/businesses`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBusinessesResponseFromJSON(jsonValue));
    }

    /**
     * Get businesses of user
     */
    async getBusinesses(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBusinessesResponse> {
        const response = await this.getBusinessesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get a feature flag
     */
    async getFeatureFlagRaw(requestParameters: GetFeatureFlagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FeatureFlagResponse>> {
        if (requestParameters['client_app'] == null) {
            throw new runtime.RequiredError(
                'client_app',
                'Required parameter "client_app" was null or undefined when calling getFeatureFlag().'
            );
        }

        if (requestParameters['feature_flag'] == null) {
            throw new runtime.RequiredError(
                'feature_flag',
                'Required parameter "feature_flag" was null or undefined when calling getFeatureFlag().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/feature-flags/{client-app}/{feature-flag}`.replace(`{${"client-app"}}`, encodeURIComponent(String(requestParameters['client_app']))).replace(`{${"feature-flag"}}`, encodeURIComponent(String(requestParameters['feature_flag']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FeatureFlagResponseFromJSON(jsonValue));
    }

    /**
     * Get a feature flag
     */
    async getFeatureFlag(requestParameters: GetFeatureFlagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FeatureFlagResponse> {
        const response = await this.getFeatureFlagRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get impersonator data
     */
    async getImpersonatorDataRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MobileImpersonatorResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ops/mobile/impersonator`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MobileImpersonatorResponseFromJSON(jsonValue));
    }

    /**
     * Get impersonator data
     */
    async getImpersonatorData(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MobileImpersonatorResponse> {
        const response = await this.getImpersonatorDataRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get inactive users by business
     */
    async getInactiveUsersByBusinessRaw(requestParameters: GetInactiveUsersByBusinessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetInactiveFoodicsUsersResponse>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling getInactiveUsersByBusiness().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/integrations/foodics/{business_id}/accounts/inactive`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetInactiveFoodicsUsersResponseFromJSON(jsonValue));
    }

    /**
     * Get inactive users by business
     */
    async getInactiveUsersByBusiness(requestParameters: GetInactiveUsersByBusinessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetInactiveFoodicsUsersResponse> {
        const response = await this.getInactiveUsersByBusinessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a branch\'s products with net sales and quantity
     */
    async getMenuMixBranchProductsWithNetSalesAndQuantityRaw(requestParameters: GetMenuMixBranchProductsWithNetSalesAndQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MenuMixBranchProductsWithNetSalesAndQuantityListResponse>> {
        if (requestParameters['branch_id'] == null) {
            throw new runtime.RequiredError(
                'branch_id',
                'Required parameter "branch_id" was null or undefined when calling getMenuMixBranchProductsWithNetSalesAndQuantity().'
            );
        }

        if (requestParameters['page'] == null) {
            throw new runtime.RequiredError(
                'page',
                'Required parameter "page" was null or undefined when calling getMenuMixBranchProductsWithNetSalesAndQuantity().'
            );
        }

        if (requestParameters['page_size'] == null) {
            throw new runtime.RequiredError(
                'page_size',
                'Required parameter "page_size" was null or undefined when calling getMenuMixBranchProductsWithNetSalesAndQuantity().'
            );
        }

        if (requestParameters['order_by'] == null) {
            throw new runtime.RequiredError(
                'order_by',
                'Required parameter "order_by" was null or undefined when calling getMenuMixBranchProductsWithNetSalesAndQuantity().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['time_period'] != null) {
            queryParameters['time-period'] = requestParameters['time_period'];
        }

        if (requestParameters['date_range_start'] != null) {
            queryParameters['date-range-start'] = (requestParameters['date_range_start'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['date_range_end'] != null) {
            queryParameters['date-range-end'] = (requestParameters['date_range_end'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['page_size'] != null) {
            queryParameters['page-size'] = requestParameters['page_size'];
        }

        if (requestParameters['order_by'] != null) {
            queryParameters['order-by'] = requestParameters['order_by'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/menu-mix/branch/{branch_id}/products/with-net-sales-and-quantity`.replace(`{${"branch_id"}}`, encodeURIComponent(String(requestParameters['branch_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MenuMixBranchProductsWithNetSalesAndQuantityListResponseFromJSON(jsonValue));
    }

    /**
     * Get a branch\'s products with net sales and quantity
     */
    async getMenuMixBranchProductsWithNetSalesAndQuantity(requestParameters: GetMenuMixBranchProductsWithNetSalesAndQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MenuMixBranchProductsWithNetSalesAndQuantityListResponse> {
        const response = await this.getMenuMixBranchProductsWithNetSalesAndQuantityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a business\' branches with quantity
     */
    async getMenuMixBusinessBranchesWithQuantityRaw(requestParameters: GetMenuMixBusinessBranchesWithQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MenuMixBusinessBranchesWithQuantityResponse>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling getMenuMixBusinessBranchesWithQuantity().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['time_period'] != null) {
            queryParameters['time-period'] = requestParameters['time_period'];
        }

        if (requestParameters['date_range_start'] != null) {
            queryParameters['date-range-start'] = (requestParameters['date_range_start'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['date_range_end'] != null) {
            queryParameters['date-range-end'] = (requestParameters['date_range_end'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/menu-mix/business/{business_id}/branches/with-quantity`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MenuMixBusinessBranchesWithQuantityResponseFromJSON(jsonValue));
    }

    /**
     * Get a business\' branches with quantity
     */
    async getMenuMixBusinessBranchesWithQuantity(requestParameters: GetMenuMixBusinessBranchesWithQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MenuMixBusinessBranchesWithQuantityResponse> {
        const response = await this.getMenuMixBusinessBranchesWithQuantityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a business\' product branches with net sales and quantity
     */
    async getMenuMixBusinessProductBranchesWithNetSalesAndQuantityRaw(requestParameters: GetMenuMixBusinessProductBranchesWithNetSalesAndQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MenuMixBusinessProductBranchesWithNetSalesAndQuantityResponse>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling getMenuMixBusinessProductBranchesWithNetSalesAndQuantity().'
            );
        }

        if (requestParameters['product_id'] == null) {
            throw new runtime.RequiredError(
                'product_id',
                'Required parameter "product_id" was null or undefined when calling getMenuMixBusinessProductBranchesWithNetSalesAndQuantity().'
            );
        }

        if (requestParameters['order_by'] == null) {
            throw new runtime.RequiredError(
                'order_by',
                'Required parameter "order_by" was null or undefined when calling getMenuMixBusinessProductBranchesWithNetSalesAndQuantity().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['time_period'] != null) {
            queryParameters['time-period'] = requestParameters['time_period'];
        }

        if (requestParameters['date_range_start'] != null) {
            queryParameters['date-range-start'] = (requestParameters['date_range_start'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['date_range_end'] != null) {
            queryParameters['date-range-end'] = (requestParameters['date_range_end'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['order_by'] != null) {
            queryParameters['order-by'] = requestParameters['order_by'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/menu-mix/business/{business_id}/product/{product_id}/branches/with-net-sales-and-quantity`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))).replace(`{${"product_id"}}`, encodeURIComponent(String(requestParameters['product_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MenuMixBusinessProductBranchesWithNetSalesAndQuantityResponseFromJSON(jsonValue));
    }

    /**
     * Get a business\' product branches with net sales and quantity
     */
    async getMenuMixBusinessProductBranchesWithNetSalesAndQuantity(requestParameters: GetMenuMixBusinessProductBranchesWithNetSalesAndQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MenuMixBusinessProductBranchesWithNetSalesAndQuantityResponse> {
        const response = await this.getMenuMixBusinessProductBranchesWithNetSalesAndQuantityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a business\' product categories with net sales
     */
    async getMenuMixBusinessProductCategoriesWithNetSalesRaw(requestParameters: GetMenuMixBusinessProductCategoriesWithNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MenuMixBusinessProductCategoriesWithNetSalesListResponse>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling getMenuMixBusinessProductCategoriesWithNetSales().'
            );
        }

        if (requestParameters['page'] == null) {
            throw new runtime.RequiredError(
                'page',
                'Required parameter "page" was null or undefined when calling getMenuMixBusinessProductCategoriesWithNetSales().'
            );
        }

        if (requestParameters['page_size'] == null) {
            throw new runtime.RequiredError(
                'page_size',
                'Required parameter "page_size" was null or undefined when calling getMenuMixBusinessProductCategoriesWithNetSales().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['time_period'] != null) {
            queryParameters['time-period'] = requestParameters['time_period'];
        }

        if (requestParameters['date_range_start'] != null) {
            queryParameters['date-range-start'] = (requestParameters['date_range_start'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['date_range_end'] != null) {
            queryParameters['date-range-end'] = (requestParameters['date_range_end'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['page_size'] != null) {
            queryParameters['page-size'] = requestParameters['page_size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/menu-mix/business/{business_id}/product-categories/with-net-sales`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MenuMixBusinessProductCategoriesWithNetSalesListResponseFromJSON(jsonValue));
    }

    /**
     * Get a business\' product categories with net sales
     */
    async getMenuMixBusinessProductCategoriesWithNetSales(requestParameters: GetMenuMixBusinessProductCategoriesWithNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MenuMixBusinessProductCategoriesWithNetSalesListResponse> {
        const response = await this.getMenuMixBusinessProductCategoriesWithNetSalesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a business\' product category branches with net sales
     */
    async getMenuMixBusinessProductCategoryBranchesWithNetSalesRaw(requestParameters: GetMenuMixBusinessProductCategoryBranchesWithNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MenuMixBusinessProductCategoryBranchesWithNetSalesResponse>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling getMenuMixBusinessProductCategoryBranchesWithNetSales().'
            );
        }

        if (requestParameters['category_id'] == null) {
            throw new runtime.RequiredError(
                'category_id',
                'Required parameter "category_id" was null or undefined when calling getMenuMixBusinessProductCategoryBranchesWithNetSales().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['time_period'] != null) {
            queryParameters['time-period'] = requestParameters['time_period'];
        }

        if (requestParameters['date_range_start'] != null) {
            queryParameters['date-range-start'] = (requestParameters['date_range_start'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['date_range_end'] != null) {
            queryParameters['date-range-end'] = (requestParameters['date_range_end'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/menu-mix/business/{business_id}/product-category/{category_id}/branches/with-net-sales`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))).replace(`{${"category_id"}}`, encodeURIComponent(String(requestParameters['category_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MenuMixBusinessProductCategoryBranchesWithNetSalesResponseFromJSON(jsonValue));
    }

    /**
     * Get a business\' product category branches with net sales
     */
    async getMenuMixBusinessProductCategoryBranchesWithNetSales(requestParameters: GetMenuMixBusinessProductCategoryBranchesWithNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MenuMixBusinessProductCategoryBranchesWithNetSalesResponse> {
        const response = await this.getMenuMixBusinessProductCategoryBranchesWithNetSalesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a business\' product category order tags with net sales
     */
    async getMenuMixBusinessProductCategoryOrderTagsWithNetSalesRaw(requestParameters: GetMenuMixBusinessProductCategoryOrderTagsWithNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MenuMixBusinessProductCategoryOrderTagsWithNetSalesResponse>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling getMenuMixBusinessProductCategoryOrderTagsWithNetSales().'
            );
        }

        if (requestParameters['category_id'] == null) {
            throw new runtime.RequiredError(
                'category_id',
                'Required parameter "category_id" was null or undefined when calling getMenuMixBusinessProductCategoryOrderTagsWithNetSales().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['time_period'] != null) {
            queryParameters['time-period'] = requestParameters['time_period'];
        }

        if (requestParameters['date_range_start'] != null) {
            queryParameters['date-range-start'] = (requestParameters['date_range_start'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['date_range_end'] != null) {
            queryParameters['date-range-end'] = (requestParameters['date_range_end'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/menu-mix/business/{business_id}/product-category/{category_id}/order-tags/with-net-sales`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))).replace(`{${"category_id"}}`, encodeURIComponent(String(requestParameters['category_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MenuMixBusinessProductCategoryOrderTagsWithNetSalesResponseFromJSON(jsonValue));
    }

    /**
     * Get a business\' product category order tags with net sales
     */
    async getMenuMixBusinessProductCategoryOrderTagsWithNetSales(requestParameters: GetMenuMixBusinessProductCategoryOrderTagsWithNetSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MenuMixBusinessProductCategoryOrderTagsWithNetSalesResponse> {
        const response = await this.getMenuMixBusinessProductCategoryOrderTagsWithNetSalesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a business\' product order tags with net sales and quantity
     */
    async getMenuMixBusinessProductOrderTagsWithNetSalesAndQuantityRaw(requestParameters: GetMenuMixBusinessProductOrderTagsWithNetSalesAndQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MenuMixBusinessProductOrderTagsWithNetSalesAndQuantityResponse>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling getMenuMixBusinessProductOrderTagsWithNetSalesAndQuantity().'
            );
        }

        if (requestParameters['product_id'] == null) {
            throw new runtime.RequiredError(
                'product_id',
                'Required parameter "product_id" was null or undefined when calling getMenuMixBusinessProductOrderTagsWithNetSalesAndQuantity().'
            );
        }

        if (requestParameters['order_by'] == null) {
            throw new runtime.RequiredError(
                'order_by',
                'Required parameter "order_by" was null or undefined when calling getMenuMixBusinessProductOrderTagsWithNetSalesAndQuantity().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['time_period'] != null) {
            queryParameters['time-period'] = requestParameters['time_period'];
        }

        if (requestParameters['date_range_start'] != null) {
            queryParameters['date-range-start'] = (requestParameters['date_range_start'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['date_range_end'] != null) {
            queryParameters['date-range-end'] = (requestParameters['date_range_end'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['order_by'] != null) {
            queryParameters['order-by'] = requestParameters['order_by'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/menu-mix/business/{business_id}/product/{product_id}/order-tags/with-net-sales-and-quantity`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))).replace(`{${"product_id"}}`, encodeURIComponent(String(requestParameters['product_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MenuMixBusinessProductOrderTagsWithNetSalesAndQuantityResponseFromJSON(jsonValue));
    }

    /**
     * Get a business\' product order tags with net sales and quantity
     */
    async getMenuMixBusinessProductOrderTagsWithNetSalesAndQuantity(requestParameters: GetMenuMixBusinessProductOrderTagsWithNetSalesAndQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MenuMixBusinessProductOrderTagsWithNetSalesAndQuantityResponse> {
        const response = await this.getMenuMixBusinessProductOrderTagsWithNetSalesAndQuantityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get timeseries of a business\' products quantity sold
     */
    async getMenuMixBusinessProductsQuantityTimeseriesRaw(requestParameters: GetMenuMixBusinessProductsQuantityTimeseriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MenuMixBusinessProductsQuantityTimeseriesResponse>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling getMenuMixBusinessProductsQuantityTimeseries().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['time_period'] != null) {
            queryParameters['time-period'] = requestParameters['time_period'];
        }

        if (requestParameters['date_range_start'] != null) {
            queryParameters['date-range-start'] = (requestParameters['date_range_start'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['date_range_end'] != null) {
            queryParameters['date-range-end'] = (requestParameters['date_range_end'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/menu-mix/business/{business_id}/products-quantity-timeseries`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MenuMixBusinessProductsQuantityTimeseriesResponseFromJSON(jsonValue));
    }

    /**
     * Get timeseries of a business\' products quantity sold
     */
    async getMenuMixBusinessProductsQuantityTimeseries(requestParameters: GetMenuMixBusinessProductsQuantityTimeseriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MenuMixBusinessProductsQuantityTimeseriesResponse> {
        const response = await this.getMenuMixBusinessProductsQuantityTimeseriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a business\' products with net sales and quantity
     */
    async getMenuMixBusinessProductsWithNetSalesAndQuantityRaw(requestParameters: GetMenuMixBusinessProductsWithNetSalesAndQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MenuMixBusinessProductsWithNetSalesAndQuantityListResponse>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling getMenuMixBusinessProductsWithNetSalesAndQuantity().'
            );
        }

        if (requestParameters['page'] == null) {
            throw new runtime.RequiredError(
                'page',
                'Required parameter "page" was null or undefined when calling getMenuMixBusinessProductsWithNetSalesAndQuantity().'
            );
        }

        if (requestParameters['page_size'] == null) {
            throw new runtime.RequiredError(
                'page_size',
                'Required parameter "page_size" was null or undefined when calling getMenuMixBusinessProductsWithNetSalesAndQuantity().'
            );
        }

        if (requestParameters['order_by'] == null) {
            throw new runtime.RequiredError(
                'order_by',
                'Required parameter "order_by" was null or undefined when calling getMenuMixBusinessProductsWithNetSalesAndQuantity().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['time_period'] != null) {
            queryParameters['time-period'] = requestParameters['time_period'];
        }

        if (requestParameters['date_range_start'] != null) {
            queryParameters['date-range-start'] = (requestParameters['date_range_start'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['date_range_end'] != null) {
            queryParameters['date-range-end'] = (requestParameters['date_range_end'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['page_size'] != null) {
            queryParameters['page-size'] = requestParameters['page_size'];
        }

        if (requestParameters['order_by'] != null) {
            queryParameters['order-by'] = requestParameters['order_by'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/menu-mix/business/{business_id}/products/with-net-sales-and-quantity`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MenuMixBusinessProductsWithNetSalesAndQuantityListResponseFromJSON(jsonValue));
    }

    /**
     * Get a business\' products with net sales and quantity
     */
    async getMenuMixBusinessProductsWithNetSalesAndQuantity(requestParameters: GetMenuMixBusinessProductsWithNetSalesAndQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MenuMixBusinessProductsWithNetSalesAndQuantityListResponse> {
        const response = await this.getMenuMixBusinessProductsWithNetSalesAndQuantityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get an orders list of business
     */
    async getOrdersBusinessListRaw(requestParameters: GetOrdersBusinessListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrdersListResponse>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling getOrdersBusinessList().'
            );
        }

        if (requestParameters['page'] == null) {
            throw new runtime.RequiredError(
                'page',
                'Required parameter "page" was null or undefined when calling getOrdersBusinessList().'
            );
        }

        if (requestParameters['page_size'] == null) {
            throw new runtime.RequiredError(
                'page_size',
                'Required parameter "page_size" was null or undefined when calling getOrdersBusinessList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['time_period'] != null) {
            queryParameters['time-period'] = requestParameters['time_period'];
        }

        if (requestParameters['date_range_start'] != null) {
            queryParameters['date-range-start'] = (requestParameters['date_range_start'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['date_range_end'] != null) {
            queryParameters['date-range-end'] = (requestParameters['date_range_end'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['page_size'] != null) {
            queryParameters['page-size'] = requestParameters['page_size'];
        }

        if (requestParameters['venue_ids'] != null) {
            queryParameters['venue-ids'] = requestParameters['venue_ids']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['order_tag_ids'] != null) {
            queryParameters['order-tag-ids'] = requestParameters['order_tag_ids']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['creator_ids'] != null) {
            queryParameters['creator-ids'] = requestParameters['creator_ids']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['order_by'] != null) {
            queryParameters['order-by'] = requestParameters['order_by'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/orders/business/{business_id}/list`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrdersListResponseFromJSON(jsonValue));
    }

    /**
     * Get an orders list of business
     */
    async getOrdersBusinessList(requestParameters: GetOrdersBusinessListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrdersListResponse> {
        const response = await this.getOrdersBusinessListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get filter options for orders of business
     */
    async getOrdersBusinessListFilterOptionsRaw(requestParameters: GetOrdersBusinessListFilterOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrdersListFilterOptionsResponse>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling getOrdersBusinessListFilterOptions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['time_period'] != null) {
            queryParameters['time-period'] = requestParameters['time_period'];
        }

        if (requestParameters['date_range_start'] != null) {
            queryParameters['date-range-start'] = (requestParameters['date_range_start'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['date_range_end'] != null) {
            queryParameters['date-range-end'] = (requestParameters['date_range_end'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/orders/business/{business_id}/list/filter-options`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrdersListFilterOptionsResponseFromJSON(jsonValue));
    }

    /**
     * Get filter options for orders of business
     */
    async getOrdersBusinessListFilterOptions(requestParameters: GetOrdersBusinessListFilterOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrdersListFilterOptionsResponse> {
        const response = await this.getOrdersBusinessListFilterOptionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get an extended order of business
     */
    async getOrdersBusinessVenueOrderRaw(requestParameters: GetOrdersBusinessVenueOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExtendedOrder>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling getOrdersBusinessVenueOrder().'
            );
        }

        if (requestParameters['venue_id'] == null) {
            throw new runtime.RequiredError(
                'venue_id',
                'Required parameter "venue_id" was null or undefined when calling getOrdersBusinessVenueOrder().'
            );
        }

        if (requestParameters['order_id'] == null) {
            throw new runtime.RequiredError(
                'order_id',
                'Required parameter "order_id" was null or undefined when calling getOrdersBusinessVenueOrder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/orders/business/{business_id}/venue/{venue_id}/order/{order_id}`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))).replace(`{${"venue_id"}}`, encodeURIComponent(String(requestParameters['venue_id']))).replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters['order_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExtendedOrderFromJSON(jsonValue));
    }

    /**
     * Get an extended order of business
     */
    async getOrdersBusinessVenueOrder(requestParameters: GetOrdersBusinessVenueOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExtendedOrder> {
        const response = await this.getOrdersBusinessVenueOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the users of the logged in user\'s organization
     */
    async getOrganizationUsersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUsersByOrganizationResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organization/users`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUsersByOrganizationResponseFromJSON(jsonValue));
    }

    /**
     * Get the users of the logged in user\'s organization
     */
    async getOrganizationUsers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUsersByOrganizationResponse> {
        const response = await this.getOrganizationUsersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get the current organization Foodics user sync status
     */
    async getOrganizationUsersSyncRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationUsersSyncResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organization/users/sync`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationUsersSyncResponseFromJSON(jsonValue));
    }

    /**
     * Get the current organization Foodics user sync status
     */
    async getOrganizationUsersSync(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationUsersSyncResponse> {
        const response = await this.getOrganizationUsersSyncRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get cumulative info for the account of a business
     */
    async getProfileBusinessAccountCumulativeInfoRaw(requestParameters: GetProfileBusinessAccountCumulativeInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccountCumulativeInfo>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling getProfileBusinessAccountCumulativeInfo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/profile/business/{business_id}/account-cumulative-info`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccountCumulativeInfoFromJSON(jsonValue));
    }

    /**
     * Get cumulative info for the account of a business
     */
    async getProfileBusinessAccountCumulativeInfo(requestParameters: GetProfileBusinessAccountCumulativeInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccountCumulativeInfo> {
        const response = await this.getProfileBusinessAccountCumulativeInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get customer success info of a business
     */
    async getProfileBusinessCustomerSuccessRaw(requestParameters: GetProfileBusinessCustomerSuccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerSuccessInfo>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling getProfileBusinessCustomerSuccess().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/profile/business/{business_id}/customer-success`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomerSuccessInfoFromJSON(jsonValue));
    }

    /**
     * Get customer success info of a business
     */
    async getProfileBusinessCustomerSuccess(requestParameters: GetProfileBusinessCustomerSuccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerSuccessInfo> {
        const response = await this.getProfileBusinessCustomerSuccessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get general info for a business
     */
    async getProfileBusinessInfoRaw(requestParameters: GetProfileBusinessInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessInfo>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling getProfileBusinessInfo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/profile/business/{business_id}/info`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BusinessInfoFromJSON(jsonValue));
    }

    /**
     * Get general info for a business
     */
    async getProfileBusinessInfo(requestParameters: GetProfileBusinessInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessInfo> {
        const response = await this.getProfileBusinessInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the invoices of a business
     */
    async getProfileBusinessInvoicesRaw(requestParameters: GetProfileBusinessInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProfileInvoicesResponse>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling getProfileBusinessInvoices().'
            );
        }

        if (requestParameters['page'] == null) {
            throw new runtime.RequiredError(
                'page',
                'Required parameter "page" was null or undefined when calling getProfileBusinessInvoices().'
            );
        }

        if (requestParameters['page_size'] == null) {
            throw new runtime.RequiredError(
                'page_size',
                'Required parameter "page_size" was null or undefined when calling getProfileBusinessInvoices().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['page_size'] != null) {
            queryParameters['page-size'] = requestParameters['page_size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/profile/business/{business_id}/invoices`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProfileInvoicesResponseFromJSON(jsonValue));
    }

    /**
     * Get the invoices of a business
     */
    async getProfileBusinessInvoices(requestParameters: GetProfileBusinessInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProfileInvoicesResponse> {
        const response = await this.getProfileBusinessInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get cumulative info about invoices for a business
     */
    async getProfileBusinessInvoicesCumulativeInfoRaw(requestParameters: GetProfileBusinessInvoicesCumulativeInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvoicesCumulativeInfo>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling getProfileBusinessInvoicesCumulativeInfo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/profile/business/{business_id}/invoices/cumulative-info`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoicesCumulativeInfoFromJSON(jsonValue));
    }

    /**
     * Get cumulative info about invoices for a business
     */
    async getProfileBusinessInvoicesCumulativeInfo(requestParameters: GetProfileBusinessInvoicesCumulativeInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvoicesCumulativeInfo> {
        const response = await this.getProfileBusinessInvoicesCumulativeInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the licenses of a business
     */
    async getProfileBusinessLicensesRaw(requestParameters: GetProfileBusinessLicensesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Licenses>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling getProfileBusinessLicenses().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/profile/business/{business_id}/licenses`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LicensesFromJSON(jsonValue));
    }

    /**
     * Get the licenses of a business
     */
    async getProfileBusinessLicenses(requestParameters: GetProfileBusinessLicensesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Licenses> {
        const response = await this.getProfileBusinessLicensesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get support tickets of a business
     */
    async getProfileBusinessSupportTicketsRaw(requestParameters: GetProfileBusinessSupportTicketsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProfileSupportTicketsResponse>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling getProfileBusinessSupportTickets().'
            );
        }

        if (requestParameters['page'] == null) {
            throw new runtime.RequiredError(
                'page',
                'Required parameter "page" was null or undefined when calling getProfileBusinessSupportTickets().'
            );
        }

        if (requestParameters['page_size'] == null) {
            throw new runtime.RequiredError(
                'page_size',
                'Required parameter "page_size" was null or undefined when calling getProfileBusinessSupportTickets().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['page_size'] != null) {
            queryParameters['page-size'] = requestParameters['page_size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/profile/business/{business_id}/support-tickets`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProfileSupportTicketsResponseFromJSON(jsonValue));
    }

    /**
     * Get support tickets of a business
     */
    async getProfileBusinessSupportTickets(requestParameters: GetProfileBusinessSupportTicketsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProfileSupportTicketsResponse> {
        const response = await this.getProfileBusinessSupportTicketsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Refresh auth
     */
    async getRefreshRaw(requestParameters: GetRefreshRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Token>> {
        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling getRefresh().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['token'] != null) {
            queryParameters['token'] = requestParameters['token'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/refresh`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TokenFromJSON(jsonValue));
    }

    /**
     * Refresh auth
     */
    async getRefresh(requestParameters: GetRefreshRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Token> {
        const response = await this.getRefreshRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update self
     * Self endpoint
     */
    async getSelfRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserAggregate>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/self`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserAggregateFromJSON(jsonValue));
    }

    /**
     * Update self
     * Self endpoint
     */
    async getSelf(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserAggregate> {
        const response = await this.getSelfRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get the currency of a business
     */
    async getSettingsCurrencyRaw(requestParameters: GetSettingsCurrencyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Currency>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling getSettingsCurrency().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/settings/businesses/{business_id}/currency`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CurrencyFromJSON(jsonValue));
    }

    /**
     * Get the currency of a business
     */
    async getSettingsCurrency(requestParameters: GetSettingsCurrencyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Currency> {
        const response = await this.getSettingsCurrencyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the timezone of a business
     */
    async getSettingsTimezoneRaw(requestParameters: GetSettingsTimezoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Timezone>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling getSettingsTimezone().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/settings/businesses/{business_id}/timezone`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TimezoneFromJSON(jsonValue));
    }

    /**
     * Get the timezone of a business
     */
    async getSettingsTimezone(requestParameters: GetSettingsTimezoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Timezone> {
        const response = await this.getSettingsTimezoneRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns information about the status of the biserver service
     */
    async getStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StatusResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StatusResponseFromJSON(jsonValue));
    }

    /**
     * Returns information about the status of the biserver service
     */
    async getStatus(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StatusResponse> {
        const response = await this.getStatusRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get custom thoughtspot liveboards
     */
    async getThoughtspotCustomLiveboardsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetThoughtspotLiveboardsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/integrations/thoughtspot/custom-liveboards`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetThoughtspotLiveboardsResponseFromJSON(jsonValue));
    }

    /**
     * Get custom thoughtspot liveboards
     */
    async getThoughtspotCustomLiveboards(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetThoughtspotLiveboardsResponse> {
        const response = await this.getThoughtspotCustomLiveboardsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get thoughtspot liveboards
     */
    async getThoughtspotLiveboardsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetThoughtspotLiveboardsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/integrations/thoughtspot/liveboards`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetThoughtspotLiveboardsResponseFromJSON(jsonValue));
    }

    /**
     * Get thoughtspot liveboards
     */
    async getThoughtspotLiveboards(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetThoughtspotLiveboardsResponse> {
        const response = await this.getThoughtspotLiveboardsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get thoughtspot schedules
     */
    async getThoughtspotSchedulesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetThoughtspotSchedulesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/integrations/thoughtspot/schedules`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetThoughtspotSchedulesResponseFromJSON(jsonValue));
    }

    /**
     * Get thoughtspot schedules
     */
    async getThoughtspotSchedules(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetThoughtspotSchedulesResponse> {
        const response = await this.getThoughtspotSchedulesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get thoughtspot data sources for the search data feature
     */
    async getThoughtspotSearchDataDataSourcesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetThoughtspotDataSourcesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/integrations/thoughtspot/search-data/data-sources`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetThoughtspotDataSourcesResponseFromJSON(jsonValue));
    }

    /**
     * Get thoughtspot data sources for the search data feature
     */
    async getThoughtspotSearchDataDataSources(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetThoughtspotDataSourcesResponse> {
        const response = await this.getThoughtspotSearchDataDataSourcesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get thoughtspot token
     */
    async getThoughtspotTokenRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ThoughtspotToken>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/integrations/thoughtspot/token`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ThoughtspotTokenFromJSON(jsonValue));
    }

    /**
     * Get thoughtspot token
     */
    async getThoughtspotToken(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ThoughtspotToken> {
        const response = await this.getThoughtspotTokenRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get users by business
     */
    async getUsersByBusinessRaw(requestParameters: GetUsersByBusinessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUsersByBusinessResponse>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling getUsersByBusiness().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/businesses/{business_id}/users`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUsersByBusinessResponseFromJSON(jsonValue));
    }

    /**
     * Get users by business
     */
    async getUsersByBusiness(requestParameters: GetUsersByBusinessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUsersByBusinessResponse> {
        const response = await this.getUsersByBusinessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Impersonate another user
     */
    async impersonateRaw(requestParameters: ImpersonateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ImpersonateResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling impersonate().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ops/impersonate`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ImpersonateResponseFromJSON(jsonValue));
    }

    /**
     * Impersonate another user
     */
    async impersonate(requestParameters: ImpersonateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ImpersonateResponse> {
        const response = await this.impersonateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update business
     */
    async patchBusinessesBusinessIdRaw(requestParameters: PatchBusinessesBusinessIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Business>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling patchBusinessesBusinessId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/businesses/{business_id}`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateBusinessRequestToJSON(requestParameters['UpdateBusinessRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BusinessFromJSON(jsonValue));
    }

    /**
     * Update business
     */
    async patchBusinessesBusinessId(requestParameters: PatchBusinessesBusinessIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Business> {
        const response = await this.patchBusinessesBusinessIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upload a budget file
     */
    async postBudgetRaw(requestParameters: PostBudgetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling postBudget().'
            );
        }

        if (requestParameters['year'] == null) {
            throw new runtime.RequiredError(
                'year',
                'Required parameter "year" was null or undefined when calling postBudget().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['year'] != null) {
            queryParameters['year'] = requestParameters['year'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/budget/{business_id}/upload`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Upload a budget file
     */
    async postBudget(requestParameters: PostBudgetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postBudgetRaw(requestParameters, initOverrides);
    }

    /**
     * Change password
     */
    async postChangePasswordRaw(requestParameters: PostChangePasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/self/password`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChangePasswordRequestToJSON(requestParameters['ChangePasswordRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Change password
     */
    async postChangePassword(requestParameters: PostChangePasswordRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postChangePasswordRaw(requestParameters, initOverrides);
    }

    /**
     * Exchange a Foodics RMS session for a restricted host-business BI session
     */
    async postFoodicsMiniappBusinessSessionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MiniAppBusinessSessionResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Foodics_RMS_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/foodics/miniapp/business-session`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MiniAppBusinessSessionResponseFromJSON(jsonValue));
    }

    /**
     * Exchange a Foodics RMS session for a restricted host-business BI session
     */
    async postFoodicsMiniappBusinessSession(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MiniAppBusinessSessionResponse> {
        const response = await this.postFoodicsMiniappBusinessSessionRaw(initOverrides);
        return await response.value();
    }

    /**
     * Exchange a Foodics RMS session for a BI session
     */
    async postFoodicsMiniappTokenExchangeRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoginResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Foodics_RMS_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/foodics/miniapp/token/exchange`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginResponseFromJSON(jsonValue));
    }

    /**
     * Exchange a Foodics RMS session for a BI session
     */
    async postFoodicsMiniappTokenExchange(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoginResponse> {
        const response = await this.postFoodicsMiniappTokenExchangeRaw(initOverrides);
        return await response.value();
    }

    /**
     * Email OTP login instructions to Foodics users in a business
     */
    async postInviteFoodicsAccountsRaw(requestParameters: PostInviteFoodicsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['business_id'] == null) {
            throw new runtime.RequiredError(
                'business_id',
                'Required parameter "business_id" was null or undefined when calling postInviteFoodicsAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/integrations/foodics/{business_id}/accounts/invite`.replace(`{${"business_id"}}`, encodeURIComponent(String(requestParameters['business_id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InviteFoodicsAccountsRequestToJSON(requestParameters['InviteFoodicsAccountsRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Email OTP login instructions to Foodics users in a business
     */
    async postInviteFoodicsAccounts(requestParameters: PostInviteFoodicsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postInviteFoodicsAccountsRaw(requestParameters, initOverrides);
    }

    /**
     */
    async postLoginRaw(requestParameters: PostLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoginResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/login`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LoginRequestToJSON(requestParameters['LoginRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginResponseFromJSON(jsonValue));
    }

    /**
     */
    async postLogin(requestParameters: PostLoginRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoginResponse> {
        const response = await this.postLoginRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Log in to an existing BI demo account without an email code
     */
    async postLoginDemoRaw(requestParameters: PostLoginDemoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoginResponse>> {
        if (requestParameters['DemoLoginRequest'] == null) {
            throw new runtime.RequiredError(
                'DemoLoginRequest',
                'Required parameter "DemoLoginRequest" was null or undefined when calling postLoginDemo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/login/demo`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DemoLoginRequestToJSON(requestParameters['DemoLoginRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginResponseFromJSON(jsonValue));
    }

    /**
     * Log in to an existing BI demo account without an email code
     */
    async postLoginDemo(requestParameters: PostLoginDemoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoginResponse> {
        const response = await this.postLoginDemoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Request an email code for Foodics BI login
     */
    async postLoginOtpChallengeRaw(requestParameters: PostLoginOtpChallengeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RequestOTPChallengeResponse>> {
        if (requestParameters['RequestOTPChallengeRequest'] == null) {
            throw new runtime.RequiredError(
                'RequestOTPChallengeRequest',
                'Required parameter "RequestOTPChallengeRequest" was null or undefined when calling postLoginOtpChallenge().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/login/otp/challenge`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestOTPChallengeRequestToJSON(requestParameters['RequestOTPChallengeRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RequestOTPChallengeResponseFromJSON(jsonValue));
    }

    /**
     * Request an email code for Foodics BI login
     */
    async postLoginOtpChallenge(requestParameters: PostLoginOtpChallengeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RequestOTPChallengeResponse> {
        const response = await this.postLoginOtpChallengeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Verify an email code and log in
     */
    async postLoginOtpVerifyRaw(requestParameters: PostLoginOtpVerifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VerifyOTPChallengeResponse>> {
        if (requestParameters['VerifyOTPChallengeRequest'] == null) {
            throw new runtime.RequiredError(
                'VerifyOTPChallengeRequest',
                'Required parameter "VerifyOTPChallengeRequest" was null or undefined when calling postLoginOtpVerify().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/login/otp/verify`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VerifyOTPChallengeRequestToJSON(requestParameters['VerifyOTPChallengeRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VerifyOTPChallengeResponseFromJSON(jsonValue));
    }

    /**
     * Verify an email code and log in
     */
    async postLoginOtpVerify(requestParameters: PostLoginOtpVerifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VerifyOTPChallengeResponse> {
        const response = await this.postLoginOtpVerifyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async postLogoutRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/logout`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async postLogout(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postLogoutRaw(initOverrides);
    }

    /**
     */
    async postOpsLoginRaw(requestParameters: PostOpsLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminLoginResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/ops/login`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminLoginRequestToJSON(requestParameters['AdminLoginRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminLoginResponseFromJSON(jsonValue));
    }

    /**
     */
    async postOpsLogin(requestParameters: PostOpsLoginRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminLoginResponse> {
        const response = await this.postOpsLoginRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Verifies a code requested through /login/otp/challenge. An uninstalled business starts installation in this organization; an installed business moves here when the verified user is also a root in its current organization.
     * Add a Foodics business to the signed-in root user\'s organization
     */
    async postOrganizationBusinessesOtpVerifyRaw(requestParameters: PostOrganizationBusinessesOtpVerifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AddBusinessOTPResponse>> {
        if (requestParameters['AddBusinessOTPRequest'] == null) {
            throw new runtime.RequiredError(
                'AddBusinessOTPRequest',
                'Required parameter "AddBusinessOTPRequest" was null or undefined when calling postOrganizationBusinessesOtpVerify().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organization/businesses/otp/verify`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddBusinessOTPRequestToJSON(requestParameters['AddBusinessOTPRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AddBusinessOTPResponseFromJSON(jsonValue));
    }

    /**
     * Verifies a code requested through /login/otp/challenge. An uninstalled business starts installation in this organization; an installed business moves here when the verified user is also a root in its current organization.
     * Add a Foodics business to the signed-in root user\'s organization
     */
    async postOrganizationBusinessesOtpVerify(requestParameters: PostOrganizationBusinessesOtpVerifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AddBusinessOTPResponse> {
        const response = await this.postOrganizationBusinessesOtpVerifyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Start a manual organization Foodics user sync when eligible
     */
    async postOrganizationUsersSyncRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationUsersSyncResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organization/users/sync`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationUsersSyncResponseFromJSON(jsonValue));
    }

    /**
     * Start a manual organization Foodics user sync when eligible
     */
    async postOrganizationUsersSync(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationUsersSyncResponse> {
        const response = await this.postOrganizationUsersSyncRaw(initOverrides);
        return await response.value();
    }

    /**
     * Request reset password
     */
    async postRequestResetPasswordRaw(requestParameters: PostRequestResetPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RequestResetPasswordResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/request-reset-password`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestResetPasswordRequestToJSON(requestParameters['RequestResetPasswordRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RequestResetPasswordResponseFromJSON(jsonValue));
    }

    /**
     * Request reset password
     */
    async postRequestResetPassword(requestParameters: PostRequestResetPasswordRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RequestResetPasswordResponse> {
        const response = await this.postRequestResetPasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Reset password
     */
    async postResetPasswordRaw(requestParameters: PostResetPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoginResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/reset-password`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ResetPasswordRequestToJSON(requestParameters['ResetPasswordRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginResponseFromJSON(jsonValue));
    }

    /**
     * Reset password
     */
    async postResetPassword(requestParameters: PostResetPasswordRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoginResponse> {
        const response = await this.postResetPasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Change business context
     */
    async postSelfBusinessContextRaw(requestParameters: PostSelfBusinessContextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/self/business-context`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChangeBusinessContextRequestToJSON(requestParameters['ChangeBusinessContextRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Change business context
     */
    async postSelfBusinessContext(requestParameters: PostSelfBusinessContextRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postSelfBusinessContextRaw(requestParameters, initOverrides);
    }

    /**
     * Change enterprise web app liveboards order
     */
    async postSelfEnterpriseWebAppLiveboardsOrderRaw(requestParameters: PostSelfEnterpriseWebAppLiveboardsOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/self/enterprise-web-app/liveboards-order`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['LiveboardCategory']!.map(LiveboardCategoryToJSON),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Change enterprise web app liveboards order
     */
    async postSelfEnterpriseWebAppLiveboardsOrder(requestParameters: PostSelfEnterpriseWebAppLiveboardsOrderRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postSelfEnterpriseWebAppLiveboardsOrderRaw(requestParameters, initOverrides);
    }

    /**
     * Change enterprise web app mode
     */
    async postSelfEnterpriseWebAppModeRaw(requestParameters: PostSelfEnterpriseWebAppModeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/self/enterprise-web-app/mode`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChangeModeRequestToJSON(requestParameters['ChangeModeRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Change enterprise web app mode
     */
    async postSelfEnterpriseWebAppMode(requestParameters: PostSelfEnterpriseWebAppModeRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postSelfEnterpriseWebAppModeRaw(requestParameters, initOverrides);
    }

    /**
     * Create a new liveboard
     */
    async postThoughtspotLiveboardsCreateRaw(requestParameters: PostThoughtspotLiveboardsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ThoughtspotLiveboardsCreateResponse>> {
        if (requestParameters['liveboard_name'] == null) {
            throw new runtime.RequiredError(
                'liveboard_name',
                'Required parameter "liveboard_name" was null or undefined when calling postThoughtspotLiveboardsCreate().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['liveboard_name'] != null) {
            queryParameters['liveboard_name'] = requestParameters['liveboard_name'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/integrations/thoughtspot/liveboards/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ThoughtspotLiveboardsCreateResponseFromJSON(jsonValue));
    }

    /**
     * Create a new liveboard
     */
    async postThoughtspotLiveboardsCreate(requestParameters: PostThoughtspotLiveboardsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ThoughtspotLiveboardsCreateResponse> {
        const response = await this.postThoughtspotLiveboardsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Unfavorite thoughtspot liveboard
     */
    async unfavoriteThoughtspotLiveboardRaw(requestParameters: UnfavoriteThoughtspotLiveboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['liveboard_id'] == null) {
            throw new runtime.RequiredError(
                'liveboard_id',
                'Required parameter "liveboard_id" was null or undefined when calling unfavoriteThoughtspotLiveboard().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['liveboard_id'] != null) {
            queryParameters['liveboard_id'] = requestParameters['liveboard_id'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/integrations/thoughtspot/liveboards/favorite`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Unfavorite thoughtspot liveboard
     */
    async unfavoriteThoughtspotLiveboard(requestParameters: UnfavoriteThoughtspotLiveboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.unfavoriteThoughtspotLiveboardRaw(requestParameters, initOverrides);
    }

    /**
     * Update a user\'s web app privileges
     */
    async updateUserWebAppPrivilegesRaw(requestParameters: UpdateUserWebAppPrivilegesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['user_id'] == null) {
            throw new runtime.RequiredError(
                'user_id',
                'Required parameter "user_id" was null or undefined when calling updateUserWebAppPrivileges().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/users/{user_id}/web-app-privileges`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['user_id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update a user\'s web app privileges
     */
    async updateUserWebAppPrivileges(requestParameters: UpdateUserWebAppPrivilegesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateUserWebAppPrivilegesRaw(requestParameters, initOverrides);
    }

    /**
     * Promote user to admin
     */
    async usersPromoteUserRaw(requestParameters: UsersPromoteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['user_id'] == null) {
            throw new runtime.RequiredError(
                'user_id',
                'Required parameter "user_id" was null or undefined when calling usersPromoteUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Norma_BI_token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/users/{user_id}/promote`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['user_id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Promote user to admin
     */
    async usersPromoteUser(requestParameters: UsersPromoteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.usersPromoteUserRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const GetBranchAppsNetSalesTimePeriodEnum = {
    today: 'today',
    yesterday: 'yesterday',
    this_week: 'this-week',
    last_week: 'last-week',
    this_month: 'this-month',
    last_month: 'last-month',
    this_year: 'this-year'
} as const;
export type GetBranchAppsNetSalesTimePeriodEnum = typeof GetBranchAppsNetSalesTimePeriodEnum[keyof typeof GetBranchAppsNetSalesTimePeriodEnum];
/**
 * @export
 */
export const GetBranchGeneralMetricsTimePeriodEnum = {
    today: 'today',
    yesterday: 'yesterday',
    this_week: 'this-week',
    last_week: 'last-week',
    this_month: 'this-month',
    last_month: 'last-month',
    this_year: 'this-year'
} as const;
export type GetBranchGeneralMetricsTimePeriodEnum = typeof GetBranchGeneralMetricsTimePeriodEnum[keyof typeof GetBranchGeneralMetricsTimePeriodEnum];
/**
 * @export
 */
export const GetBranchNetSalesTimeseriesTimePeriodEnum = {
    today: 'today',
    yesterday: 'yesterday',
    this_week: 'this-week',
    last_week: 'last-week',
    this_month: 'this-month',
    last_month: 'last-month',
    this_year: 'this-year'
} as const;
export type GetBranchNetSalesTimeseriesTimePeriodEnum = typeof GetBranchNetSalesTimeseriesTimePeriodEnum[keyof typeof GetBranchNetSalesTimeseriesTimePeriodEnum];
/**
 * @export
 */
export const GetBranchOrderSourcesNetSalesTimePeriodEnum = {
    today: 'today',
    yesterday: 'yesterday',
    this_week: 'this-week',
    last_week: 'last-week',
    this_month: 'this-month',
    last_month: 'last-month',
    this_year: 'this-year'
} as const;
export type GetBranchOrderSourcesNetSalesTimePeriodEnum = typeof GetBranchOrderSourcesNetSalesTimePeriodEnum[keyof typeof GetBranchOrderSourcesNetSalesTimePeriodEnum];
/**
 * @export
 */
export const GetBranchOrderTagsNetSalesTimePeriodEnum = {
    today: 'today',
    yesterday: 'yesterday',
    this_week: 'this-week',
    last_week: 'last-week',
    this_month: 'this-month',
    last_month: 'last-month',
    this_year: 'this-year'
} as const;
export type GetBranchOrderTagsNetSalesTimePeriodEnum = typeof GetBranchOrderTagsNetSalesTimePeriodEnum[keyof typeof GetBranchOrderTagsNetSalesTimePeriodEnum];
/**
 * @export
 */
export const GetBranchOrderTypesNetSalesTimePeriodEnum = {
    today: 'today',
    yesterday: 'yesterday',
    this_week: 'this-week',
    last_week: 'last-week',
    this_month: 'this-month',
    last_month: 'last-month',
    this_year: 'this-year'
} as const;
export type GetBranchOrderTypesNetSalesTimePeriodEnum = typeof GetBranchOrderTypesNetSalesTimePeriodEnum[keyof typeof GetBranchOrderTypesNetSalesTimePeriodEnum];
/**
 * @export
 */
export const GetBranchPaymentMethodsNetAmountTimePeriodEnum = {
    today: 'today',
    yesterday: 'yesterday',
    this_week: 'this-week',
    last_week: 'last-week',
    this_month: 'this-month',
    last_month: 'last-month',
    this_year: 'this-year'
} as const;
export type GetBranchPaymentMethodsNetAmountTimePeriodEnum = typeof GetBranchPaymentMethodsNetAmountTimePeriodEnum[keyof typeof GetBranchPaymentMethodsNetAmountTimePeriodEnum];
/**
 * @export
 */
export const GetBranchesNetSalesTimeseriesTimePeriodEnum = {
    today: 'today',
    yesterday: 'yesterday',
    this_week: 'this-week',
    last_week: 'last-week',
    this_month: 'this-month',
    last_month: 'last-month',
    this_year: 'this-year'
} as const;
export type GetBranchesNetSalesTimeseriesTimePeriodEnum = typeof GetBranchesNetSalesTimeseriesTimePeriodEnum[keyof typeof GetBranchesNetSalesTimeseriesTimePeriodEnum];
/**
 * @export
 */
export const GetBranchesReportTimePeriodEnum = {
    today: 'today',
    yesterday: 'yesterday',
    this_week: 'this-week',
    last_week: 'last-week',
    this_month: 'this-month',
    last_month: 'last-month',
    this_year: 'this-year'
} as const;
export type GetBranchesReportTimePeriodEnum = typeof GetBranchesReportTimePeriodEnum[keyof typeof GetBranchesReportTimePeriodEnum];
/**
 * @export
 */
export const GetBudgetResolutionEnum = {
    weekly: 'weekly',
    monthly: 'monthly'
} as const;
export type GetBudgetResolutionEnum = typeof GetBudgetResolutionEnum[keyof typeof GetBudgetResolutionEnum];
/**
 * @export
 */
export const GetBudgetTemplateResolutionEnum = {
    weekly: 'weekly',
    monthly: 'monthly'
} as const;
export type GetBudgetTemplateResolutionEnum = typeof GetBudgetTemplateResolutionEnum[keyof typeof GetBudgetTemplateResolutionEnum];
/**
 * @export
 */
export const GetBudgetXlsxResolutionEnum = {
    weekly: 'weekly',
    monthly: 'monthly'
} as const;
export type GetBudgetXlsxResolutionEnum = typeof GetBudgetXlsxResolutionEnum[keyof typeof GetBudgetXlsxResolutionEnum];
/**
 * @export
 */
export const GetBusinessAppsNetSalesTimePeriodEnum = {
    today: 'today',
    yesterday: 'yesterday',
    this_week: 'this-week',
    last_week: 'last-week',
    this_month: 'this-month',
    last_month: 'last-month',
    this_year: 'this-year'
} as const;
export type GetBusinessAppsNetSalesTimePeriodEnum = typeof GetBusinessAppsNetSalesTimePeriodEnum[keyof typeof GetBusinessAppsNetSalesTimePeriodEnum];
/**
 * @export
 */
export const GetBusinessBranchesWithDiscountAmountAndQuantityTimePeriodEnum = {
    today: 'today',
    yesterday: 'yesterday',
    this_week: 'this-week',
    last_week: 'last-week',
    this_month: 'this-month',
    last_month: 'last-month',
    this_year: 'this-year'
} as const;
export type GetBusinessBranchesWithDiscountAmountAndQuantityTimePeriodEnum = typeof GetBusinessBranchesWithDiscountAmountAndQuantityTimePeriodEnum[keyof typeof GetBusinessBranchesWithDiscountAmountAndQuantityTimePeriodEnum];
/**
 * @export
 */
export const GetBusinessBranchesWithNetAmountPerPaymentMethodTimePeriodEnum = {
    today: 'today',
    yesterday: 'yesterday',
    this_week: 'this-week',
    last_week: 'last-week',
    this_month: 'this-month',
    last_month: 'last-month',
    this_year: 'this-year'
} as const;
export type GetBusinessBranchesWithNetAmountPerPaymentMethodTimePeriodEnum = typeof GetBusinessBranchesWithNetAmountPerPaymentMethodTimePeriodEnum[keyof typeof GetBusinessBranchesWithNetAmountPerPaymentMethodTimePeriodEnum];
/**
 * @export
 */
export const GetBusinessBranchesWithNetSalesAndOrderCountPerMarketplaceAppTimePeriodEnum = {
    today: 'today',
    yesterday: 'yesterday',
    this_week: 'this-week',
    last_week: 'last-week',
    this_month: 'this-month',
    last_month: 'last-month',
    this_year: 'this-year'
} as const;
export type GetBusinessBranchesWithNetSalesAndOrderCountPerMarketplaceAppTimePeriodEnum = typeof GetBusinessBranchesWithNetSalesAndOrderCountPerMarketplaceAppTimePeriodEnum[keyof typeof GetBusinessBranchesWithNetSalesAndOrderCountPerMarketplaceAppTimePeriodEnum];
/**
 * @export
 */
export const GetBusinessBranchesWithNetSalesAndOrderCountPerOrderSourceTimePeriodEnum = {
    today: 'today',
    yesterday: 'yesterday',
    this_week: 'this-week',
    last_week: 'last-week',
    this_month: 'this-month',
    last_month: 'last-month',
    this_year: 'this-year'
} as const;
export type GetBusinessBranchesWithNetSalesAndOrderCountPerOrderSourceTimePeriodEnum = typeof GetBusinessBranchesWithNetSalesAndOrderCountPerOrderSourceTimePeriodEnum[keyof typeof GetBusinessBranchesWithNetSalesAndOrderCountPerOrderSourceTimePeriodEnum];
/**
 * @export
 */
export const GetBusinessBranchesWithNetSalesAndOrderCountPerOrderTagTimePeriodEnum = {
    today: 'today',
    yesterday: 'yesterday',
    this_week: 'this-week',
    last_week: 'last-week',
    this_month: 'this-month',
    last_month: 'last-month',
    this_year: 'this-year'
} as const;
export type GetBusinessBranchesWithNetSalesAndOrderCountPerOrderTagTimePeriodEnum = typeof GetBusinessBranchesWithNetSalesAndOrderCountPerOrderTagTimePeriodEnum[keyof typeof GetBusinessBranchesWithNetSalesAndOrderCountPerOrderTagTimePeriodEnum];
/**
 * @export
 */
export const GetBusinessBranchesWithNetSalesAndOrderCountPerOrderTypeTimePeriodEnum = {
    today: 'today',
    yesterday: 'yesterday',
    this_week: 'this-week',
    last_week: 'last-week',
    this_month: 'this-month',
    last_month: 'last-month',
    this_year: 'this-year'
} as const;
export type GetBusinessBranchesWithNetSalesAndOrderCountPerOrderTypeTimePeriodEnum = typeof GetBusinessBranchesWithNetSalesAndOrderCountPerOrderTypeTimePeriodEnum[keyof typeof GetBusinessBranchesWithNetSalesAndOrderCountPerOrderTypeTimePeriodEnum];
/**
 * @export
 */
export const GetBusinessBranchesWithNetSalesPerOrderAndOrderCountTimePeriodEnum = {
    today: 'today',
    yesterday: 'yesterday',
    this_week: 'this-week',
    last_week: 'last-week',
    this_month: 'this-month',
    last_month: 'last-month',
    this_year: 'this-year'
} as const;
export type GetBusinessBranchesWithNetSalesPerOrderAndOrderCountTimePeriodEnum = typeof GetBusinessBranchesWithNetSalesPerOrderAndOrderCountTimePeriodEnum[keyof typeof GetBusinessBranchesWithNetSalesPerOrderAndOrderCountTimePeriodEnum];
/**
 * @export
 */
export const GetBusinessBranchesWithOrderCountAndNetSalesTimePeriodEnum = {
    today: 'today',
    yesterday: 'yesterday',
    this_week: 'this-week',
    last_week: 'last-week',
    this_month: 'this-month',
    last_month: 'last-month',
    this_year: 'this-year'
} as const;
export type GetBusinessBranchesWithOrderCountAndNetSalesTimePeriodEnum = typeof GetBusinessBranchesWithOrderCountAndNetSalesTimePeriodEnum[keyof typeof GetBusinessBranchesWithOrderCountAndNetSalesTimePeriodEnum];
/**
 * @export
 */
export const GetBusinessBranchesWithVoidAmountAndQuantityTimePeriodEnum = {
    today: 'today',
    yesterday: 'yesterday',
    this_week: 'this-week',
    last_week: 'last-week',
    this_month: 'this-month',
    last_month: 'last-month',
    this_year: 'this-year'
} as const;
export type GetBusinessBranchesWithVoidAmountAndQuantityTimePeriodEnum = typeof GetBusinessBranchesWithVoidAmountAndQuantityTimePeriodEnum[keyof typeof GetBusinessBranchesWithVoidAmountAndQuantityTimePeriodEnum];
/**
 * @export
 */
export const GetBusinessGeneralMetricsTimePeriodEnum = {
    today: 'today',
    yesterday: 'yesterday',
    this_week: 'this-week',
    last_week: 'last-week',
    this_month: 'this-month',
    last_month: 'last-month',
    this_year: 'this-year'
} as const;
export type GetBusinessGeneralMetricsTimePeriodEnum = typeof GetBusinessGeneralMetricsTimePeriodEnum[keyof typeof GetBusinessGeneralMetricsTimePeriodEnum];
/**
 * @export
 */
export const GetBusinessNetSalesTimeseriesTimePeriodEnum = {
    today: 'today',
    yesterday: 'yesterday',
    this_week: 'this-week',
    last_week: 'last-week',
    this_month: 'this-month',
    last_month: 'last-month',
    this_year: 'this-year'
} as const;
export type GetBusinessNetSalesTimeseriesTimePeriodEnum = typeof GetBusinessNetSalesTimeseriesTimePeriodEnum[keyof typeof GetBusinessNetSalesTimeseriesTimePeriodEnum];
/**
 * @export
 */
export const GetBusinessOrderSourcesNetSalesTimePeriodEnum = {
    today: 'today',
    yesterday: 'yesterday',
    this_week: 'this-week',
    last_week: 'last-week',
    this_month: 'this-month',
    last_month: 'last-month',
    this_year: 'this-year'
} as const;
export type GetBusinessOrderSourcesNetSalesTimePeriodEnum = typeof GetBusinessOrderSourcesNetSalesTimePeriodEnum[keyof typeof GetBusinessOrderSourcesNetSalesTimePeriodEnum];
/**
 * @export
 */
export const GetBusinessOrderTagsNetSalesTimePeriodEnum = {
    today: 'today',
    yesterday: 'yesterday',
    this_week: 'this-week',
    last_week: 'last-week',
    this_month: 'this-month',
    last_month: 'last-month',
    this_year: 'this-year'
} as const;
export type GetBusinessOrderTagsNetSalesTimePeriodEnum = typeof GetBusinessOrderTagsNetSalesTimePeriodEnum[keyof typeof GetBusinessOrderTagsNetSalesTimePeriodEnum];
/**
 * @export
 */
export const GetBusinessOrderTypesNetSalesTimePeriodEnum = {
    today: 'today',
    yesterday: 'yesterday',
    this_week: 'this-week',
    last_week: 'last-week',
    this_month: 'this-month',
    last_month: 'last-month',
    this_year: 'this-year'
} as const;
export type GetBusinessOrderTypesNetSalesTimePeriodEnum = typeof GetBusinessOrderTypesNetSalesTimePeriodEnum[keyof typeof GetBusinessOrderTypesNetSalesTimePeriodEnum];
/**
 * @export
 */
export const GetBusinessPaymentMethodsNetAmountTimePeriodEnum = {
    today: 'today',
    yesterday: 'yesterday',
    this_week: 'this-week',
    last_week: 'last-week',
    this_month: 'this-month',
    last_month: 'last-month',
    this_year: 'this-year'
} as const;
export type GetBusinessPaymentMethodsNetAmountTimePeriodEnum = typeof GetBusinessPaymentMethodsNetAmountTimePeriodEnum[keyof typeof GetBusinessPaymentMethodsNetAmountTimePeriodEnum];
/**
 * @export
 */
export const GetFeatureFlagClientAppEnum = {
    web_app: 'web-app',
    mobile_app: 'mobile-app'
} as const;
export type GetFeatureFlagClientAppEnum = typeof GetFeatureFlagClientAppEnum[keyof typeof GetFeatureFlagClientAppEnum];
/**
 * @export
 */
export const GetFeatureFlagFeatureFlagEnum = {
    chat: 'chat',
    licensing: 'licensing',
    s_chat: 's_chat',
    s_full_app: 's_full_app'
} as const;
export type GetFeatureFlagFeatureFlagEnum = typeof GetFeatureFlagFeatureFlagEnum[keyof typeof GetFeatureFlagFeatureFlagEnum];
/**
 * @export
 */
export const GetMenuMixBranchProductsWithNetSalesAndQuantityTimePeriodEnum = {
    today: 'today',
    yesterday: 'yesterday',
    this_week: 'this-week',
    last_week: 'last-week',
    this_month: 'this-month',
    last_month: 'last-month',
    this_year: 'this-year'
} as const;
export type GetMenuMixBranchProductsWithNetSalesAndQuantityTimePeriodEnum = typeof GetMenuMixBranchProductsWithNetSalesAndQuantityTimePeriodEnum[keyof typeof GetMenuMixBranchProductsWithNetSalesAndQuantityTimePeriodEnum];
/**
 * @export
 */
export const GetMenuMixBusinessBranchesWithQuantityTimePeriodEnum = {
    today: 'today',
    yesterday: 'yesterday',
    this_week: 'this-week',
    last_week: 'last-week',
    this_month: 'this-month',
    last_month: 'last-month',
    this_year: 'this-year'
} as const;
export type GetMenuMixBusinessBranchesWithQuantityTimePeriodEnum = typeof GetMenuMixBusinessBranchesWithQuantityTimePeriodEnum[keyof typeof GetMenuMixBusinessBranchesWithQuantityTimePeriodEnum];
/**
 * @export
 */
export const GetMenuMixBusinessProductBranchesWithNetSalesAndQuantityTimePeriodEnum = {
    today: 'today',
    yesterday: 'yesterday',
    this_week: 'this-week',
    last_week: 'last-week',
    this_month: 'this-month',
    last_month: 'last-month',
    this_year: 'this-year'
} as const;
export type GetMenuMixBusinessProductBranchesWithNetSalesAndQuantityTimePeriodEnum = typeof GetMenuMixBusinessProductBranchesWithNetSalesAndQuantityTimePeriodEnum[keyof typeof GetMenuMixBusinessProductBranchesWithNetSalesAndQuantityTimePeriodEnum];
/**
 * @export
 */
export const GetMenuMixBusinessProductCategoriesWithNetSalesTimePeriodEnum = {
    today: 'today',
    yesterday: 'yesterday',
    this_week: 'this-week',
    last_week: 'last-week',
    this_month: 'this-month',
    last_month: 'last-month',
    this_year: 'this-year'
} as const;
export type GetMenuMixBusinessProductCategoriesWithNetSalesTimePeriodEnum = typeof GetMenuMixBusinessProductCategoriesWithNetSalesTimePeriodEnum[keyof typeof GetMenuMixBusinessProductCategoriesWithNetSalesTimePeriodEnum];
/**
 * @export
 */
export const GetMenuMixBusinessProductCategoryBranchesWithNetSalesTimePeriodEnum = {
    today: 'today',
    yesterday: 'yesterday',
    this_week: 'this-week',
    last_week: 'last-week',
    this_month: 'this-month',
    last_month: 'last-month',
    this_year: 'this-year'
} as const;
export type GetMenuMixBusinessProductCategoryBranchesWithNetSalesTimePeriodEnum = typeof GetMenuMixBusinessProductCategoryBranchesWithNetSalesTimePeriodEnum[keyof typeof GetMenuMixBusinessProductCategoryBranchesWithNetSalesTimePeriodEnum];
/**
 * @export
 */
export const GetMenuMixBusinessProductCategoryOrderTagsWithNetSalesTimePeriodEnum = {
    today: 'today',
    yesterday: 'yesterday',
    this_week: 'this-week',
    last_week: 'last-week',
    this_month: 'this-month',
    last_month: 'last-month',
    this_year: 'this-year'
} as const;
export type GetMenuMixBusinessProductCategoryOrderTagsWithNetSalesTimePeriodEnum = typeof GetMenuMixBusinessProductCategoryOrderTagsWithNetSalesTimePeriodEnum[keyof typeof GetMenuMixBusinessProductCategoryOrderTagsWithNetSalesTimePeriodEnum];
/**
 * @export
 */
export const GetMenuMixBusinessProductOrderTagsWithNetSalesAndQuantityTimePeriodEnum = {
    today: 'today',
    yesterday: 'yesterday',
    this_week: 'this-week',
    last_week: 'last-week',
    this_month: 'this-month',
    last_month: 'last-month',
    this_year: 'this-year'
} as const;
export type GetMenuMixBusinessProductOrderTagsWithNetSalesAndQuantityTimePeriodEnum = typeof GetMenuMixBusinessProductOrderTagsWithNetSalesAndQuantityTimePeriodEnum[keyof typeof GetMenuMixBusinessProductOrderTagsWithNetSalesAndQuantityTimePeriodEnum];
/**
 * @export
 */
export const GetMenuMixBusinessProductsQuantityTimeseriesTimePeriodEnum = {
    today: 'today',
    yesterday: 'yesterday',
    this_week: 'this-week',
    last_week: 'last-week',
    this_month: 'this-month',
    last_month: 'last-month',
    this_year: 'this-year'
} as const;
export type GetMenuMixBusinessProductsQuantityTimeseriesTimePeriodEnum = typeof GetMenuMixBusinessProductsQuantityTimeseriesTimePeriodEnum[keyof typeof GetMenuMixBusinessProductsQuantityTimeseriesTimePeriodEnum];
/**
 * @export
 */
export const GetMenuMixBusinessProductsWithNetSalesAndQuantityTimePeriodEnum = {
    today: 'today',
    yesterday: 'yesterday',
    this_week: 'this-week',
    last_week: 'last-week',
    this_month: 'this-month',
    last_month: 'last-month',
    this_year: 'this-year'
} as const;
export type GetMenuMixBusinessProductsWithNetSalesAndQuantityTimePeriodEnum = typeof GetMenuMixBusinessProductsWithNetSalesAndQuantityTimePeriodEnum[keyof typeof GetMenuMixBusinessProductsWithNetSalesAndQuantityTimePeriodEnum];
/**
 * @export
 */
export const GetOrdersBusinessListTimePeriodEnum = {
    today: 'today',
    yesterday: 'yesterday',
    this_week: 'this-week',
    last_week: 'last-week',
    this_month: 'this-month',
    last_month: 'last-month',
    this_year: 'this-year'
} as const;
export type GetOrdersBusinessListTimePeriodEnum = typeof GetOrdersBusinessListTimePeriodEnum[keyof typeof GetOrdersBusinessListTimePeriodEnum];
/**
 * @export
 */
export const GetOrdersBusinessListFilterOptionsTimePeriodEnum = {
    today: 'today',
    yesterday: 'yesterday',
    this_week: 'this-week',
    last_week: 'last-week',
    this_month: 'this-month',
    last_month: 'last-month',
    this_year: 'this-year'
} as const;
export type GetOrdersBusinessListFilterOptionsTimePeriodEnum = typeof GetOrdersBusinessListFilterOptionsTimePeriodEnum[keyof typeof GetOrdersBusinessListFilterOptionsTimePeriodEnum];
